var ia = Object.defineProperty;
var oa = (e, r, t) => r in e ? ia(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var R = (e, r, t) => (oa(e, typeof r != "symbol" ? r + "" : r, t), t);
import * as he from "react";
import q, { createElement as nt } from "react";
import { flushSync as ca } from "react-dom";
function Zr() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Qr(e) {
  function r(t) {
    var n = this.constructor.getDerivedStateFromProps(e, t);
    return n != null ? n : null;
  }
  this.setState(r.bind(this));
}
function en(e, r) {
  try {
    var t = this.props, n = this.state;
    this.props = e, this.state = r, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      t,
      n
    );
  } finally {
    this.props = t, this.state = n;
  }
}
Zr.__suppressDeprecationWarning = !0;
Qr.__suppressDeprecationWarning = !0;
en.__suppressDeprecationWarning = !0;
function tn(e) {
  var r = e.prototype;
  if (!r || !r.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof r.getSnapshotBeforeUpdate != "function")
    return e;
  var t = null, n = null, a = null;
  if (typeof r.componentWillMount == "function" ? t = "componentWillMount" : typeof r.UNSAFE_componentWillMount == "function" && (t = "UNSAFE_componentWillMount"), typeof r.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof r.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof r.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof r.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), t !== null || n !== null || a !== null) {
    var s = e.displayName || e.name, i = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + s + " uses " + i + " but also contains the following legacy lifecycles:" + (t !== null ? `
  ` + t : "") + (n !== null ? `
  ` + n : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (r.componentWillMount = Zr, r.componentWillReceiveProps = Qr), typeof r.getSnapshotBeforeUpdate == "function") {
    if (typeof r.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    r.componentWillUpdate = en;
    var o = r.componentDidUpdate;
    r.componentDidUpdate = function(d, f, p) {
      var w = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : p;
      o.call(this, d, f, w);
    };
  }
  return e;
}
function ot(e) {
  return ot = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ot(e);
}
function la(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ua(e) {
  if (Array.isArray(e))
    return e;
}
function da(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, s = !1, i, o;
    try {
      for (t = t.call(e); !(a = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      s = !0, o = c;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return n;
  }
}
function lr(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function fa(e, r) {
  if (!!e) {
    if (typeof e == "string")
      return lr(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return lr(e, r);
  }
}
function pa() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rn(e, r) {
  return ua(e) || da(e, r) || fa(e, r) || pa();
}
const ha = {
  scheme: "threezerotwofour",
  author: "jan t. sott (http://github.com/idleberg)",
  base00: "#090300",
  base01: "#3a3432",
  base02: "#4a4543",
  base03: "#5c5855",
  base04: "#807d7c",
  base05: "#a5a2a2",
  base06: "#d6d5d4",
  base07: "#f7f7f7",
  base08: "#db2d20",
  base09: "#e8bbd0",
  base0A: "#fded02",
  base0B: "#01a252",
  base0C: "#b5e4f4",
  base0D: "#01a0e4",
  base0E: "#a16a94",
  base0F: "#cdab53"
}, ba = {
  scheme: "apathy",
  author: "jannik siebert (https://github.com/janniks)",
  base00: "#031A16",
  base01: "#0B342D",
  base02: "#184E45",
  base03: "#2B685E",
  base04: "#5F9C92",
  base05: "#81B5AC",
  base06: "#A7CEC8",
  base07: "#D2E7E4",
  base08: "#3E9688",
  base09: "#3E7996",
  base0A: "#3E4C96",
  base0B: "#883E96",
  base0C: "#963E4C",
  base0D: "#96883E",
  base0E: "#4C963E",
  base0F: "#3E965B"
}, va = {
  scheme: "ashes",
  author: "jannik siebert (https://github.com/janniks)",
  base00: "#1C2023",
  base01: "#393F45",
  base02: "#565E65",
  base03: "#747C84",
  base04: "#ADB3BA",
  base05: "#C7CCD1",
  base06: "#DFE2E5",
  base07: "#F3F4F5",
  base08: "#C7AE95",
  base09: "#C7C795",
  base0A: "#AEC795",
  base0B: "#95C7AE",
  base0C: "#95AEC7",
  base0D: "#AE95C7",
  base0E: "#C795AE",
  base0F: "#C79595"
}, ga = {
  scheme: "atelier dune",
  author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",
  base00: "#20201d",
  base01: "#292824",
  base02: "#6e6b5e",
  base03: "#7d7a68",
  base04: "#999580",
  base05: "#a6a28c",
  base06: "#e8e4cf",
  base07: "#fefbec",
  base08: "#d73737",
  base09: "#b65611",
  base0A: "#cfb017",
  base0B: "#60ac39",
  base0C: "#1fad83",
  base0D: "#6684e1",
  base0E: "#b854d4",
  base0F: "#d43552"
}, ya = {
  scheme: "atelier forest",
  author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",
  base00: "#1b1918",
  base01: "#2c2421",
  base02: "#68615e",
  base03: "#766e6b",
  base04: "#9c9491",
  base05: "#a8a19f",
  base06: "#e6e2e0",
  base07: "#f1efee",
  base08: "#f22c40",
  base09: "#df5320",
  base0A: "#d5911a",
  base0B: "#5ab738",
  base0C: "#00ad9c",
  base0D: "#407ee7",
  base0E: "#6666ea",
  base0F: "#c33ff3"
}, ma = {
  scheme: "atelier heath",
  author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",
  base00: "#1b181b",
  base01: "#292329",
  base02: "#695d69",
  base03: "#776977",
  base04: "#9e8f9e",
  base05: "#ab9bab",
  base06: "#d8cad8",
  base07: "#f7f3f7",
  base08: "#ca402b",
  base09: "#a65926",
  base0A: "#bb8a35",
  base0B: "#379a37",
  base0C: "#159393",
  base0D: "#516aec",
  base0E: "#7b59c0",
  base0F: "#cc33cc"
}, wa = {
  scheme: "atelier lakeside",
  author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",
  base00: "#161b1d",
  base01: "#1f292e",
  base02: "#516d7b",
  base03: "#5a7b8c",
  base04: "#7195a8",
  base05: "#7ea2b4",
  base06: "#c1e4f6",
  base07: "#ebf8ff",
  base08: "#d22d72",
  base09: "#935c25",
  base0A: "#8a8a0f",
  base0B: "#568c3b",
  base0C: "#2d8f6f",
  base0D: "#257fad",
  base0E: "#5d5db1",
  base0F: "#b72dd2"
}, Ea = {
  scheme: "atelier seaside",
  author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",
  base00: "#131513",
  base01: "#242924",
  base02: "#5e6e5e",
  base03: "#687d68",
  base04: "#809980",
  base05: "#8ca68c",
  base06: "#cfe8cf",
  base07: "#f0fff0",
  base08: "#e6193c",
  base09: "#87711d",
  base0A: "#c3c322",
  base0B: "#29a329",
  base0C: "#1999b3",
  base0D: "#3d62f5",
  base0E: "#ad2bee",
  base0F: "#e619c3"
}, xa = {
  scheme: "bespin",
  author: "jan t. sott",
  base00: "#28211c",
  base01: "#36312e",
  base02: "#5e5d5c",
  base03: "#666666",
  base04: "#797977",
  base05: "#8a8986",
  base06: "#9d9b97",
  base07: "#baae9e",
  base08: "#cf6a4c",
  base09: "#cf7d34",
  base0A: "#f9ee98",
  base0B: "#54be0d",
  base0C: "#afc4db",
  base0D: "#5ea6ea",
  base0E: "#9b859d",
  base0F: "#937121"
}, Ca = {
  scheme: "brewer",
  author: "timoth\xE9e poisot (http://github.com/tpoisot)",
  base00: "#0c0d0e",
  base01: "#2e2f30",
  base02: "#515253",
  base03: "#737475",
  base04: "#959697",
  base05: "#b7b8b9",
  base06: "#dadbdc",
  base07: "#fcfdfe",
  base08: "#e31a1c",
  base09: "#e6550d",
  base0A: "#dca060",
  base0B: "#31a354",
  base0C: "#80b1d3",
  base0D: "#3182bd",
  base0E: "#756bb1",
  base0F: "#b15928"
}, _a = {
  scheme: "bright",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#000000",
  base01: "#303030",
  base02: "#505050",
  base03: "#b0b0b0",
  base04: "#d0d0d0",
  base05: "#e0e0e0",
  base06: "#f5f5f5",
  base07: "#ffffff",
  base08: "#fb0120",
  base09: "#fc6d24",
  base0A: "#fda331",
  base0B: "#a1c659",
  base0C: "#76c7b7",
  base0D: "#6fb3d2",
  base0E: "#d381c3",
  base0F: "#be643c"
}, ka = {
  scheme: "chalk",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#151515",
  base01: "#202020",
  base02: "#303030",
  base03: "#505050",
  base04: "#b0b0b0",
  base05: "#d0d0d0",
  base06: "#e0e0e0",
  base07: "#f5f5f5",
  base08: "#fb9fb1",
  base09: "#eda987",
  base0A: "#ddb26f",
  base0B: "#acc267",
  base0C: "#12cfc0",
  base0D: "#6fc2ef",
  base0E: "#e1a3ee",
  base0F: "#deaf8f"
}, Sa = {
  scheme: "codeschool",
  author: "brettof86",
  base00: "#232c31",
  base01: "#1c3657",
  base02: "#2a343a",
  base03: "#3f4944",
  base04: "#84898c",
  base05: "#9ea7a6",
  base06: "#a7cfa3",
  base07: "#b5d8f6",
  base08: "#2a5491",
  base09: "#43820d",
  base0A: "#a03b1e",
  base0B: "#237986",
  base0C: "#b02f30",
  base0D: "#484d79",
  base0E: "#c59820",
  base0F: "#c98344"
}, Ra = {
  scheme: "colors",
  author: "mrmrs (http://clrs.cc)",
  base00: "#111111",
  base01: "#333333",
  base02: "#555555",
  base03: "#777777",
  base04: "#999999",
  base05: "#bbbbbb",
  base06: "#dddddd",
  base07: "#ffffff",
  base08: "#ff4136",
  base09: "#ff851b",
  base0A: "#ffdc00",
  base0B: "#2ecc40",
  base0C: "#7fdbff",
  base0D: "#0074d9",
  base0E: "#b10dc9",
  base0F: "#85144b"
}, nn = {
  scheme: "default",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#181818",
  base01: "#282828",
  base02: "#383838",
  base03: "#585858",
  base04: "#b8b8b8",
  base05: "#d8d8d8",
  base06: "#e8e8e8",
  base07: "#f8f8f8",
  base08: "#ab4642",
  base09: "#dc9656",
  base0A: "#f7ca88",
  base0B: "#a1b56c",
  base0C: "#86c1b9",
  base0D: "#7cafc2",
  base0E: "#ba8baf",
  base0F: "#a16946"
}, Aa = {
  scheme: "eighties",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#2d2d2d",
  base01: "#393939",
  base02: "#515151",
  base03: "#747369",
  base04: "#a09f93",
  base05: "#d3d0c8",
  base06: "#e8e6df",
  base07: "#f2f0ec",
  base08: "#f2777a",
  base09: "#f99157",
  base0A: "#ffcc66",
  base0B: "#99cc99",
  base0C: "#66cccc",
  base0D: "#6699cc",
  base0E: "#cc99cc",
  base0F: "#d27b53"
}, Oa = {
  scheme: "embers",
  author: "jannik siebert (https://github.com/janniks)",
  base00: "#16130F",
  base01: "#2C2620",
  base02: "#433B32",
  base03: "#5A5047",
  base04: "#8A8075",
  base05: "#A39A90",
  base06: "#BEB6AE",
  base07: "#DBD6D1",
  base08: "#826D57",
  base09: "#828257",
  base0A: "#6D8257",
  base0B: "#57826D",
  base0C: "#576D82",
  base0D: "#6D5782",
  base0E: "#82576D",
  base0F: "#825757"
}, Ta = {
  scheme: "flat",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#2C3E50",
  base01: "#34495E",
  base02: "#7F8C8D",
  base03: "#95A5A6",
  base04: "#BDC3C7",
  base05: "#e0e0e0",
  base06: "#f5f5f5",
  base07: "#ECF0F1",
  base08: "#E74C3C",
  base09: "#E67E22",
  base0A: "#F1C40F",
  base0B: "#2ECC71",
  base0C: "#1ABC9C",
  base0D: "#3498DB",
  base0E: "#9B59B6",
  base0F: "#be643c"
}, Pa = {
  scheme: "google",
  author: "seth wright (http://sethawright.com)",
  base00: "#1d1f21",
  base01: "#282a2e",
  base02: "#373b41",
  base03: "#969896",
  base04: "#b4b7b4",
  base05: "#c5c8c6",
  base06: "#e0e0e0",
  base07: "#ffffff",
  base08: "#CC342B",
  base09: "#F96A38",
  base0A: "#FBA922",
  base0B: "#198844",
  base0C: "#3971ED",
  base0D: "#3971ED",
  base0E: "#A36AC7",
  base0F: "#3971ED"
}, ja = {
  scheme: "grayscale",
  author: "alexandre gavioli (https://github.com/alexx2/)",
  base00: "#101010",
  base01: "#252525",
  base02: "#464646",
  base03: "#525252",
  base04: "#ababab",
  base05: "#b9b9b9",
  base06: "#e3e3e3",
  base07: "#f7f7f7",
  base08: "#7c7c7c",
  base09: "#999999",
  base0A: "#a0a0a0",
  base0B: "#8e8e8e",
  base0C: "#868686",
  base0D: "#686868",
  base0E: "#747474",
  base0F: "#5e5e5e"
}, Fa = {
  scheme: "green screen",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#001100",
  base01: "#003300",
  base02: "#005500",
  base03: "#007700",
  base04: "#009900",
  base05: "#00bb00",
  base06: "#00dd00",
  base07: "#00ff00",
  base08: "#007700",
  base09: "#009900",
  base0A: "#007700",
  base0B: "#00bb00",
  base0C: "#005500",
  base0D: "#009900",
  base0E: "#00bb00",
  base0F: "#005500"
}, Ma = {
  scheme: "harmonic16",
  author: "jannik siebert (https://github.com/janniks)",
  base00: "#0b1c2c",
  base01: "#223b54",
  base02: "#405c79",
  base03: "#627e99",
  base04: "#aabcce",
  base05: "#cbd6e2",
  base06: "#e5ebf1",
  base07: "#f7f9fb",
  base08: "#bf8b56",
  base09: "#bfbf56",
  base0A: "#8bbf56",
  base0B: "#56bf8b",
  base0C: "#568bbf",
  base0D: "#8b56bf",
  base0E: "#bf568b",
  base0F: "#bf5656"
}, Da = {
  scheme: "hopscotch",
  author: "jan t. sott",
  base00: "#322931",
  base01: "#433b42",
  base02: "#5c545b",
  base03: "#797379",
  base04: "#989498",
  base05: "#b9b5b8",
  base06: "#d5d3d5",
  base07: "#ffffff",
  base08: "#dd464c",
  base09: "#fd8b19",
  base0A: "#fdcc59",
  base0B: "#8fc13e",
  base0C: "#149b93",
  base0D: "#1290bf",
  base0E: "#c85e7c",
  base0F: "#b33508"
}, Ia = {
  scheme: "isotope",
  author: "jan t. sott",
  base00: "#000000",
  base01: "#404040",
  base02: "#606060",
  base03: "#808080",
  base04: "#c0c0c0",
  base05: "#d0d0d0",
  base06: "#e0e0e0",
  base07: "#ffffff",
  base08: "#ff0000",
  base09: "#ff9900",
  base0A: "#ff0099",
  base0B: "#33ff00",
  base0C: "#00ffff",
  base0D: "#0066ff",
  base0E: "#cc00ff",
  base0F: "#3300ff"
}, La = {
  scheme: "marrakesh",
  author: "alexandre gavioli (http://github.com/alexx2/)",
  base00: "#201602",
  base01: "#302e00",
  base02: "#5f5b17",
  base03: "#6c6823",
  base04: "#86813b",
  base05: "#948e48",
  base06: "#ccc37a",
  base07: "#faf0a5",
  base08: "#c35359",
  base09: "#b36144",
  base0A: "#a88339",
  base0B: "#18974e",
  base0C: "#75a738",
  base0D: "#477ca1",
  base0E: "#8868b3",
  base0F: "#b3588e"
}, Na = {
  scheme: "mocha",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#3B3228",
  base01: "#534636",
  base02: "#645240",
  base03: "#7e705a",
  base04: "#b8afad",
  base05: "#d0c8c6",
  base06: "#e9e1dd",
  base07: "#f5eeeb",
  base08: "#cb6077",
  base09: "#d28b71",
  base0A: "#f4bc87",
  base0B: "#beb55b",
  base0C: "#7bbda4",
  base0D: "#8ab3b5",
  base0E: "#a89bb9",
  base0F: "#bb9584"
}, Ba = {
  scheme: "monokai",
  author: "wimer hazenberg (http://www.monokai.nl)",
  base00: "#272822",
  base01: "#383830",
  base02: "#49483e",
  base03: "#75715e",
  base04: "#a59f85",
  base05: "#f8f8f2",
  base06: "#f5f4f1",
  base07: "#f9f8f5",
  base08: "#f92672",
  base09: "#fd971f",
  base0A: "#f4bf75",
  base0B: "#a6e22e",
  base0C: "#a1efe4",
  base0D: "#66d9ef",
  base0E: "#ae81ff",
  base0F: "#cc6633"
}, qa = {
  scheme: "ocean",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#2b303b",
  base01: "#343d46",
  base02: "#4f5b66",
  base03: "#65737e",
  base04: "#a7adba",
  base05: "#c0c5ce",
  base06: "#dfe1e8",
  base07: "#eff1f5",
  base08: "#bf616a",
  base09: "#d08770",
  base0A: "#ebcb8b",
  base0B: "#a3be8c",
  base0C: "#96b5b4",
  base0D: "#8fa1b3",
  base0E: "#b48ead",
  base0F: "#ab7967"
}, za = {
  scheme: "paraiso",
  author: "jan t. sott",
  base00: "#2f1e2e",
  base01: "#41323f",
  base02: "#4f424c",
  base03: "#776e71",
  base04: "#8d8687",
  base05: "#a39e9b",
  base06: "#b9b6b0",
  base07: "#e7e9db",
  base08: "#ef6155",
  base09: "#f99b15",
  base0A: "#fec418",
  base0B: "#48b685",
  base0C: "#5bc4bf",
  base0D: "#06b6ef",
  base0E: "#815ba4",
  base0F: "#e96ba8"
}, Va = {
  scheme: "pop",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#000000",
  base01: "#202020",
  base02: "#303030",
  base03: "#505050",
  base04: "#b0b0b0",
  base05: "#d0d0d0",
  base06: "#e0e0e0",
  base07: "#ffffff",
  base08: "#eb008a",
  base09: "#f29333",
  base0A: "#f8ca12",
  base0B: "#37b349",
  base0C: "#00aabb",
  base0D: "#0e5a94",
  base0E: "#b31e8d",
  base0F: "#7a2d00"
}, Wa = {
  scheme: "railscasts",
  author: "ryan bates (http://railscasts.com)",
  base00: "#2b2b2b",
  base01: "#272935",
  base02: "#3a4055",
  base03: "#5a647e",
  base04: "#d4cfc9",
  base05: "#e6e1dc",
  base06: "#f4f1ed",
  base07: "#f9f7f3",
  base08: "#da4939",
  base09: "#cc7833",
  base0A: "#ffc66d",
  base0B: "#a5c261",
  base0C: "#519f50",
  base0D: "#6d9cbe",
  base0E: "#b6b3eb",
  base0F: "#bc9458"
}, $a = {
  scheme: "shapeshifter",
  author: "tyler benziger (http://tybenz.com)",
  base00: "#000000",
  base01: "#040404",
  base02: "#102015",
  base03: "#343434",
  base04: "#555555",
  base05: "#ababab",
  base06: "#e0e0e0",
  base07: "#f9f9f9",
  base08: "#e92f2f",
  base09: "#e09448",
  base0A: "#dddd13",
  base0B: "#0ed839",
  base0C: "#23edda",
  base0D: "#3b48e3",
  base0E: "#f996e2",
  base0F: "#69542d"
}, Ka = {
  scheme: "solarized",
  author: "ethan schoonover (http://ethanschoonover.com/solarized)",
  base00: "#002b36",
  base01: "#073642",
  base02: "#586e75",
  base03: "#657b83",
  base04: "#839496",
  base05: "#93a1a1",
  base06: "#eee8d5",
  base07: "#fdf6e3",
  base08: "#dc322f",
  base09: "#cb4b16",
  base0A: "#b58900",
  base0B: "#859900",
  base0C: "#2aa198",
  base0D: "#268bd2",
  base0E: "#6c71c4",
  base0F: "#d33682"
}, Ua = {
  scheme: "summerfruit",
  author: "christopher corley (http://cscorley.github.io/)",
  base00: "#151515",
  base01: "#202020",
  base02: "#303030",
  base03: "#505050",
  base04: "#B0B0B0",
  base05: "#D0D0D0",
  base06: "#E0E0E0",
  base07: "#FFFFFF",
  base08: "#FF0086",
  base09: "#FD8900",
  base0A: "#ABA800",
  base0B: "#00C918",
  base0C: "#1faaaa",
  base0D: "#3777E6",
  base0E: "#AD00A1",
  base0F: "#cc6633"
}, Ya = {
  scheme: "tomorrow",
  author: "chris kempson (http://chriskempson.com)",
  base00: "#1d1f21",
  base01: "#282a2e",
  base02: "#373b41",
  base03: "#969896",
  base04: "#b4b7b4",
  base05: "#c5c8c6",
  base06: "#e0e0e0",
  base07: "#ffffff",
  base08: "#cc6666",
  base09: "#de935f",
  base0A: "#f0c674",
  base0B: "#b5bd68",
  base0C: "#8abeb7",
  base0D: "#81a2be",
  base0E: "#b294bb",
  base0F: "#a3685a"
}, Ha = {
  scheme: "london tube",
  author: "jan t. sott",
  base00: "#231f20",
  base01: "#1c3f95",
  base02: "#5a5758",
  base03: "#737171",
  base04: "#959ca1",
  base05: "#d9d8d8",
  base06: "#e7e7e8",
  base07: "#ffffff",
  base08: "#ee2e24",
  base09: "#f386a1",
  base0A: "#ffd204",
  base0B: "#00853e",
  base0C: "#85cebc",
  base0D: "#009ddc",
  base0E: "#98005d",
  base0F: "#b06110"
}, Ga = {
  scheme: "twilight",
  author: "david hart (http://hart-dev.com)",
  base00: "#1e1e1e",
  base01: "#323537",
  base02: "#464b50",
  base03: "#5f5a60",
  base04: "#838184",
  base05: "#a7a7a7",
  base06: "#c3c3c3",
  base07: "#ffffff",
  base08: "#cf6a4c",
  base09: "#cda869",
  base0A: "#f9ee98",
  base0B: "#8f9d6a",
  base0C: "#afc4db",
  base0D: "#7587a6",
  base0E: "#9b859d",
  base0F: "#9b703f"
}, Ja = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  threezerotwofour: ha,
  apathy: ba,
  ashes: va,
  atelierDune: ga,
  atelierForest: ya,
  atelierHeath: ma,
  atelierLakeside: wa,
  atelierSeaside: Ea,
  bespin: xa,
  brewer: Ca,
  bright: _a,
  chalk: ka,
  codeschool: Sa,
  colors: Ra,
  default: nn,
  eighties: Aa,
  embers: Oa,
  flat: Ta,
  google: Pa,
  grayscale: ja,
  greenscreen: Fa,
  harmonic: Ma,
  hopscotch: Da,
  isotope: Ia,
  marrakesh: La,
  mocha: Na,
  monokai: Ba,
  ocean: qa,
  paraiso: za,
  pop: Va,
  railscasts: Wa,
  shapeshifter: $a,
  solarized: Ka,
  summerfruit: Ua,
  tomorrow: Ya,
  tube: Ha,
  twilight: Ga
}, Symbol.toStringTag, { value: "Module" }));
var ht = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, an = { exports: {} }, Xa = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, sn = { exports: {} }, Za = function(r) {
  return !r || typeof r == "string" ? !1 : r instanceof Array || Array.isArray(r) || r.length >= 0 && (r.splice instanceof Function || Object.getOwnPropertyDescriptor(r, r.length - 1) && r.constructor.name !== "String");
}, Qa = Za, es = Array.prototype.concat, ts = Array.prototype.slice, ur = sn.exports = function(r) {
  for (var t = [], n = 0, a = r.length; n < a; n++) {
    var s = r[n];
    Qa(s) ? t = es.call(t, ts.call(s)) : t.push(s);
  }
  return t;
};
ur.wrap = function(e) {
  return function() {
    return e(ur(arguments));
  };
};
var at = Xa, ut = sn.exports, on = Object.hasOwnProperty, cn = /* @__PURE__ */ Object.create(null);
for (var At in at)
  on.call(at, At) && (cn[at[At]] = At);
var ge = an.exports = {
  to: {},
  get: {}
};
ge.get = function(e) {
  var r = e.substring(0, 3).toLowerCase(), t, n;
  switch (r) {
    case "hsl":
      t = ge.get.hsl(e), n = "hsl";
      break;
    case "hwb":
      t = ge.get.hwb(e), n = "hwb";
      break;
    default:
      t = ge.get.rgb(e), n = "rgb";
      break;
  }
  return t ? { model: n, value: t } : null;
};
ge.get.rgb = function(e) {
  if (!e)
    return null;
  var r = /^#([a-f0-9]{3,4})$/i, t = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, n = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, a = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, s = /^(\w+)$/, i = [0, 0, 0, 1], o, c, d;
  if (o = e.match(t)) {
    for (d = o[2], o = o[1], c = 0; c < 3; c++) {
      var f = c * 2;
      i[c] = parseInt(o.slice(f, f + 2), 16);
    }
    d && (i[3] = parseInt(d, 16) / 255);
  } else if (o = e.match(r)) {
    for (o = o[1], d = o[3], c = 0; c < 3; c++)
      i[c] = parseInt(o[c] + o[c], 16);
    d && (i[3] = parseInt(d + d, 16) / 255);
  } else if (o = e.match(n)) {
    for (c = 0; c < 3; c++)
      i[c] = parseInt(o[c + 1], 0);
    o[4] && (o[5] ? i[3] = parseFloat(o[4]) * 0.01 : i[3] = parseFloat(o[4]));
  } else if (o = e.match(a)) {
    for (c = 0; c < 3; c++)
      i[c] = Math.round(parseFloat(o[c + 1]) * 2.55);
    o[4] && (o[5] ? i[3] = parseFloat(o[4]) * 0.01 : i[3] = parseFloat(o[4]));
  } else
    return (o = e.match(s)) ? o[1] === "transparent" ? [0, 0, 0, 0] : on.call(at, o[1]) ? (i = at[o[1]], i[3] = 1, i) : null : null;
  for (c = 0; c < 3; c++)
    i[c] = je(i[c], 0, 255);
  return i[3] = je(i[3], 0, 1), i;
};
ge.get.hsl = function(e) {
  if (!e)
    return null;
  var r = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = e.match(r);
  if (t) {
    var n = parseFloat(t[4]), a = (parseFloat(t[1]) % 360 + 360) % 360, s = je(parseFloat(t[2]), 0, 100), i = je(parseFloat(t[3]), 0, 100), o = je(isNaN(n) ? 1 : n, 0, 1);
    return [a, s, i, o];
  }
  return null;
};
ge.get.hwb = function(e) {
  if (!e)
    return null;
  var r = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = e.match(r);
  if (t) {
    var n = parseFloat(t[4]), a = (parseFloat(t[1]) % 360 + 360) % 360, s = je(parseFloat(t[2]), 0, 100), i = je(parseFloat(t[3]), 0, 100), o = je(isNaN(n) ? 1 : n, 0, 1);
    return [a, s, i, o];
  }
  return null;
};
ge.to.hex = function() {
  var e = ut(arguments);
  return "#" + bt(e[0]) + bt(e[1]) + bt(e[2]) + (e[3] < 1 ? bt(Math.round(e[3] * 255)) : "");
};
ge.to.rgb = function() {
  var e = ut(arguments);
  return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
};
ge.to.rgb.percent = function() {
  var e = ut(arguments), r = Math.round(e[0] / 255 * 100), t = Math.round(e[1] / 255 * 100), n = Math.round(e[2] / 255 * 100);
  return e.length < 4 || e[3] === 1 ? "rgb(" + r + "%, " + t + "%, " + n + "%)" : "rgba(" + r + "%, " + t + "%, " + n + "%, " + e[3] + ")";
};
ge.to.hsl = function() {
  var e = ut(arguments);
  return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
};
ge.to.hwb = function() {
  var e = ut(arguments), r = "";
  return e.length >= 4 && e[3] !== 1 && (r = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + r + ")";
};
ge.to.keyword = function(e) {
  return cn[e.slice(0, 3)];
};
function je(e, r, t) {
  return Math.min(Math.max(r, e), t);
}
function bt(e) {
  var r = Math.round(e).toString(16).toUpperCase();
  return r.length < 2 ? "0" + r : r;
}
var Wt = { exports: {} }, rs = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Ie = rs, ln = {};
for (var Ot in Ie)
  Ie.hasOwnProperty(Ot) && (ln[Ie[Ot]] = Ot);
var _ = Wt.exports = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
for (var pe in _)
  if (_.hasOwnProperty(pe)) {
    if (!("channels" in _[pe]))
      throw new Error("missing channels property: " + pe);
    if (!("labels" in _[pe]))
      throw new Error("missing channel labels property: " + pe);
    if (_[pe].labels.length !== _[pe].channels)
      throw new Error("channel and label counts mismatch: " + pe);
    var ns = _[pe].channels, as = _[pe].labels;
    delete _[pe].channels, delete _[pe].labels, Object.defineProperty(_[pe], "channels", { value: ns }), Object.defineProperty(_[pe], "labels", { value: as });
  }
_.rgb.hsl = function(e) {
  var r = e[0] / 255, t = e[1] / 255, n = e[2] / 255, a = Math.min(r, t, n), s = Math.max(r, t, n), i = s - a, o, c, d;
  return s === a ? o = 0 : r === s ? o = (t - n) / i : t === s ? o = 2 + (n - r) / i : n === s && (o = 4 + (r - t) / i), o = Math.min(o * 60, 360), o < 0 && (o += 360), d = (a + s) / 2, s === a ? c = 0 : d <= 0.5 ? c = i / (s + a) : c = i / (2 - s - a), [o, c * 100, d * 100];
};
_.rgb.hsv = function(e) {
  var r, t, n, a, s, i = e[0] / 255, o = e[1] / 255, c = e[2] / 255, d = Math.max(i, o, c), f = d - Math.min(i, o, c), p = function(w) {
    return (d - w) / 6 / f + 1 / 2;
  };
  return f === 0 ? a = s = 0 : (s = f / d, r = p(i), t = p(o), n = p(c), i === d ? a = n - t : o === d ? a = 1 / 3 + r - n : c === d && (a = 2 / 3 + t - r), a < 0 ? a += 1 : a > 1 && (a -= 1)), [
    a * 360,
    s * 100,
    d * 100
  ];
};
_.rgb.hwb = function(e) {
  var r = e[0], t = e[1], n = e[2], a = _.rgb.hsl(e)[0], s = 1 / 255 * Math.min(r, Math.min(t, n));
  return n = 1 - 1 / 255 * Math.max(r, Math.max(t, n)), [a, s * 100, n * 100];
};
_.rgb.cmyk = function(e) {
  var r = e[0] / 255, t = e[1] / 255, n = e[2] / 255, a, s, i, o;
  return o = Math.min(1 - r, 1 - t, 1 - n), a = (1 - r - o) / (1 - o) || 0, s = (1 - t - o) / (1 - o) || 0, i = (1 - n - o) / (1 - o) || 0, [a * 100, s * 100, i * 100, o * 100];
};
function ss(e, r) {
  return Math.pow(e[0] - r[0], 2) + Math.pow(e[1] - r[1], 2) + Math.pow(e[2] - r[2], 2);
}
_.rgb.keyword = function(e) {
  var r = ln[e];
  if (r)
    return r;
  var t = 1 / 0, n;
  for (var a in Ie)
    if (Ie.hasOwnProperty(a)) {
      var s = Ie[a], i = ss(e, s);
      i < t && (t = i, n = a);
    }
  return n;
};
_.keyword.rgb = function(e) {
  return Ie[e];
};
_.rgb.xyz = function(e) {
  var r = e[0] / 255, t = e[1] / 255, n = e[2] / 255;
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92, t = t > 0.04045 ? Math.pow((t + 0.055) / 1.055, 2.4) : t / 12.92, n = n > 0.04045 ? Math.pow((n + 0.055) / 1.055, 2.4) : n / 12.92;
  var a = r * 0.4124 + t * 0.3576 + n * 0.1805, s = r * 0.2126 + t * 0.7152 + n * 0.0722, i = r * 0.0193 + t * 0.1192 + n * 0.9505;
  return [a * 100, s * 100, i * 100];
};
_.rgb.lab = function(e) {
  var r = _.rgb.xyz(e), t = r[0], n = r[1], a = r[2], s, i, o;
  return t /= 95.047, n /= 100, a /= 108.883, t = t > 8856e-6 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, a = a > 8856e-6 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, s = 116 * n - 16, i = 500 * (t - n), o = 200 * (n - a), [s, i, o];
};
_.hsl.rgb = function(e) {
  var r = e[0] / 360, t = e[1] / 100, n = e[2] / 100, a, s, i, o, c;
  if (t === 0)
    return c = n * 255, [c, c, c];
  n < 0.5 ? s = n * (1 + t) : s = n + t - n * t, a = 2 * n - s, o = [0, 0, 0];
  for (var d = 0; d < 3; d++)
    i = r + 1 / 3 * -(d - 1), i < 0 && i++, i > 1 && i--, 6 * i < 1 ? c = a + (s - a) * 6 * i : 2 * i < 1 ? c = s : 3 * i < 2 ? c = a + (s - a) * (2 / 3 - i) * 6 : c = a, o[d] = c * 255;
  return o;
};
_.hsl.hsv = function(e) {
  var r = e[0], t = e[1] / 100, n = e[2] / 100, a = t, s = Math.max(n, 0.01), i, o;
  return n *= 2, t *= n <= 1 ? n : 2 - n, a *= s <= 1 ? s : 2 - s, o = (n + t) / 2, i = n === 0 ? 2 * a / (s + a) : 2 * t / (n + t), [r, i * 100, o * 100];
};
_.hsv.rgb = function(e) {
  var r = e[0] / 60, t = e[1] / 100, n = e[2] / 100, a = Math.floor(r) % 6, s = r - Math.floor(r), i = 255 * n * (1 - t), o = 255 * n * (1 - t * s), c = 255 * n * (1 - t * (1 - s));
  switch (n *= 255, a) {
    case 0:
      return [n, c, i];
    case 1:
      return [o, n, i];
    case 2:
      return [i, n, c];
    case 3:
      return [i, o, n];
    case 4:
      return [c, i, n];
    case 5:
      return [n, i, o];
  }
};
_.hsv.hsl = function(e) {
  var r = e[0], t = e[1] / 100, n = e[2] / 100, a = Math.max(n, 0.01), s, i, o;
  return o = (2 - t) * n, s = (2 - t) * a, i = t * a, i /= s <= 1 ? s : 2 - s, i = i || 0, o /= 2, [r, i * 100, o * 100];
};
_.hwb.rgb = function(e) {
  var r = e[0] / 360, t = e[1] / 100, n = e[2] / 100, a = t + n, s, i, o, c;
  a > 1 && (t /= a, n /= a), s = Math.floor(6 * r), i = 1 - n, o = 6 * r - s, (s & 1) !== 0 && (o = 1 - o), c = t + o * (i - t);
  var d, f, p;
  switch (s) {
    default:
    case 6:
    case 0:
      d = i, f = c, p = t;
      break;
    case 1:
      d = c, f = i, p = t;
      break;
    case 2:
      d = t, f = i, p = c;
      break;
    case 3:
      d = t, f = c, p = i;
      break;
    case 4:
      d = c, f = t, p = i;
      break;
    case 5:
      d = i, f = t, p = c;
      break;
  }
  return [d * 255, f * 255, p * 255];
};
_.cmyk.rgb = function(e) {
  var r = e[0] / 100, t = e[1] / 100, n = e[2] / 100, a = e[3] / 100, s, i, o;
  return s = 1 - Math.min(1, r * (1 - a) + a), i = 1 - Math.min(1, t * (1 - a) + a), o = 1 - Math.min(1, n * (1 - a) + a), [s * 255, i * 255, o * 255];
};
_.xyz.rgb = function(e) {
  var r = e[0] / 100, t = e[1] / 100, n = e[2] / 100, a, s, i;
  return a = r * 3.2406 + t * -1.5372 + n * -0.4986, s = r * -0.9689 + t * 1.8758 + n * 0.0415, i = r * 0.0557 + t * -0.204 + n * 1.057, a = a > 31308e-7 ? 1.055 * Math.pow(a, 1 / 2.4) - 0.055 : a * 12.92, s = s > 31308e-7 ? 1.055 * Math.pow(s, 1 / 2.4) - 0.055 : s * 12.92, i = i > 31308e-7 ? 1.055 * Math.pow(i, 1 / 2.4) - 0.055 : i * 12.92, a = Math.min(Math.max(0, a), 1), s = Math.min(Math.max(0, s), 1), i = Math.min(Math.max(0, i), 1), [a * 255, s * 255, i * 255];
};
_.xyz.lab = function(e) {
  var r = e[0], t = e[1], n = e[2], a, s, i;
  return r /= 95.047, t /= 100, n /= 108.883, r = r > 8856e-6 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116, t = t > 8856e-6 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, a = 116 * t - 16, s = 500 * (r - t), i = 200 * (t - n), [a, s, i];
};
_.lab.xyz = function(e) {
  var r = e[0], t = e[1], n = e[2], a, s, i;
  s = (r + 16) / 116, a = t / 500 + s, i = s - n / 200;
  var o = Math.pow(s, 3), c = Math.pow(a, 3), d = Math.pow(i, 3);
  return s = o > 8856e-6 ? o : (s - 16 / 116) / 7.787, a = c > 8856e-6 ? c : (a - 16 / 116) / 7.787, i = d > 8856e-6 ? d : (i - 16 / 116) / 7.787, a *= 95.047, s *= 100, i *= 108.883, [a, s, i];
};
_.lab.lch = function(e) {
  var r = e[0], t = e[1], n = e[2], a, s, i;
  return a = Math.atan2(n, t), s = a * 360 / 2 / Math.PI, s < 0 && (s += 360), i = Math.sqrt(t * t + n * n), [r, i, s];
};
_.lch.lab = function(e) {
  var r = e[0], t = e[1], n = e[2], a, s, i;
  return i = n / 360 * 2 * Math.PI, a = t * Math.cos(i), s = t * Math.sin(i), [r, a, s];
};
_.rgb.ansi16 = function(e) {
  var r = e[0], t = e[1], n = e[2], a = 1 in arguments ? arguments[1] : _.rgb.hsv(e)[2];
  if (a = Math.round(a / 50), a === 0)
    return 30;
  var s = 30 + (Math.round(n / 255) << 2 | Math.round(t / 255) << 1 | Math.round(r / 255));
  return a === 2 && (s += 60), s;
};
_.hsv.ansi16 = function(e) {
  return _.rgb.ansi16(_.hsv.rgb(e), e[2]);
};
_.rgb.ansi256 = function(e) {
  var r = e[0], t = e[1], n = e[2];
  if (r === t && t === n)
    return r < 8 ? 16 : r > 248 ? 231 : Math.round((r - 8) / 247 * 24) + 232;
  var a = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(t / 255 * 5) + Math.round(n / 255 * 5);
  return a;
};
_.ansi16.rgb = function(e) {
  var r = e % 10;
  if (r === 0 || r === 7)
    return e > 50 && (r += 3.5), r = r / 10.5 * 255, [r, r, r];
  var t = (~~(e > 50) + 1) * 0.5, n = (r & 1) * t * 255, a = (r >> 1 & 1) * t * 255, s = (r >> 2 & 1) * t * 255;
  return [n, a, s];
};
_.ansi256.rgb = function(e) {
  if (e >= 232) {
    var r = (e - 232) * 10 + 8;
    return [r, r, r];
  }
  e -= 16;
  var t, n = Math.floor(e / 36) / 5 * 255, a = Math.floor((t = e % 36) / 6) / 5 * 255, s = t % 6 / 5 * 255;
  return [n, a, s];
};
_.rgb.hex = function(e) {
  var r = ((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255), t = r.toString(16).toUpperCase();
  return "000000".substring(t.length) + t;
};
_.hex.rgb = function(e) {
  var r = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!r)
    return [0, 0, 0];
  var t = r[0];
  r[0].length === 3 && (t = t.split("").map(function(o) {
    return o + o;
  }).join(""));
  var n = parseInt(t, 16), a = n >> 16 & 255, s = n >> 8 & 255, i = n & 255;
  return [a, s, i];
};
_.rgb.hcg = function(e) {
  var r = e[0] / 255, t = e[1] / 255, n = e[2] / 255, a = Math.max(Math.max(r, t), n), s = Math.min(Math.min(r, t), n), i = a - s, o, c;
  return i < 1 ? o = s / (1 - i) : o = 0, i <= 0 ? c = 0 : a === r ? c = (t - n) / i % 6 : a === t ? c = 2 + (n - r) / i : c = 4 + (r - t) / i + 4, c /= 6, c %= 1, [c * 360, i * 100, o * 100];
};
_.hsl.hcg = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = 1, a = 0;
  return t < 0.5 ? n = 2 * r * t : n = 2 * r * (1 - t), n < 1 && (a = (t - 0.5 * n) / (1 - n)), [e[0], n * 100, a * 100];
};
_.hsv.hcg = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = r * t, a = 0;
  return n < 1 && (a = (t - n) / (1 - n)), [e[0], n * 100, a * 100];
};
_.hcg.rgb = function(e) {
  var r = e[0] / 360, t = e[1] / 100, n = e[2] / 100;
  if (t === 0)
    return [n * 255, n * 255, n * 255];
  var a = [0, 0, 0], s = r % 1 * 6, i = s % 1, o = 1 - i, c = 0;
  switch (Math.floor(s)) {
    case 0:
      a[0] = 1, a[1] = i, a[2] = 0;
      break;
    case 1:
      a[0] = o, a[1] = 1, a[2] = 0;
      break;
    case 2:
      a[0] = 0, a[1] = 1, a[2] = i;
      break;
    case 3:
      a[0] = 0, a[1] = o, a[2] = 1;
      break;
    case 4:
      a[0] = i, a[1] = 0, a[2] = 1;
      break;
    default:
      a[0] = 1, a[1] = 0, a[2] = o;
  }
  return c = (1 - t) * n, [
    (t * a[0] + c) * 255,
    (t * a[1] + c) * 255,
    (t * a[2] + c) * 255
  ];
};
_.hcg.hsv = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = r + t * (1 - r), a = 0;
  return n > 0 && (a = r / n), [e[0], a * 100, n * 100];
};
_.hcg.hsl = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = t * (1 - r) + 0.5 * r, a = 0;
  return n > 0 && n < 0.5 ? a = r / (2 * n) : n >= 0.5 && n < 1 && (a = r / (2 * (1 - n))), [e[0], a * 100, n * 100];
};
_.hcg.hwb = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = r + t * (1 - r);
  return [e[0], (n - r) * 100, (1 - n) * 100];
};
_.hwb.hcg = function(e) {
  var r = e[1] / 100, t = e[2] / 100, n = 1 - t, a = n - r, s = 0;
  return a < 1 && (s = (n - a) / (1 - a)), [e[0], a * 100, s * 100];
};
_.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
_.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
_.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
_.gray.hsl = _.gray.hsv = function(e) {
  return [0, 0, e[0]];
};
_.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
_.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
_.gray.lab = function(e) {
  return [e[0], 0, 0];
};
_.gray.hex = function(e) {
  var r = Math.round(e[0] / 100 * 255) & 255, t = (r << 16) + (r << 8) + r, n = t.toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
_.rgb.gray = function(e) {
  var r = (e[0] + e[1] + e[2]) / 3;
  return [r / 255 * 100];
};
var yt = Wt.exports;
function is() {
  for (var e = {}, r = Object.keys(yt), t = r.length, n = 0; n < t; n++)
    e[r[n]] = {
      distance: -1,
      parent: null
    };
  return e;
}
function os(e) {
  var r = is(), t = [e];
  for (r[e].distance = 0; t.length; )
    for (var n = t.pop(), a = Object.keys(yt[n]), s = a.length, i = 0; i < s; i++) {
      var o = a[i], c = r[o];
      c.distance === -1 && (c.distance = r[n].distance + 1, c.parent = n, t.unshift(o));
    }
  return r;
}
function cs(e, r) {
  return function(t) {
    return r(e(t));
  };
}
function ls(e, r) {
  for (var t = [r[e].parent, e], n = yt[r[e].parent][e], a = r[e].parent; r[a].parent; )
    t.unshift(r[a].parent), n = cs(yt[r[a].parent][a], n), a = r[a].parent;
  return n.conversion = t, n;
}
var us = function(e) {
  for (var r = os(e), t = {}, n = Object.keys(r), a = n.length, s = 0; s < a; s++) {
    var i = n[s], o = r[i];
    o.parent !== null && (t[i] = ls(i, r));
  }
  return t;
}, Nt = Wt.exports, ds = us, Ue = {}, fs = Object.keys(Nt);
function ps(e) {
  var r = function(t) {
    return t == null ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), e(t));
  };
  return "conversion" in e && (r.conversion = e.conversion), r;
}
function hs(e) {
  var r = function(t) {
    if (t == null)
      return t;
    arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
    var n = e(t);
    if (typeof n == "object")
      for (var a = n.length, s = 0; s < a; s++)
        n[s] = Math.round(n[s]);
    return n;
  };
  return "conversion" in e && (r.conversion = e.conversion), r;
}
fs.forEach(function(e) {
  Ue[e] = {}, Object.defineProperty(Ue[e], "channels", { value: Nt[e].channels }), Object.defineProperty(Ue[e], "labels", { value: Nt[e].labels });
  var r = ds(e), t = Object.keys(r);
  t.forEach(function(n) {
    var a = r[n];
    Ue[e][n] = hs(a), Ue[e][n].raw = ps(a);
  });
});
var bs = Ue, tt = an.exports, ve = bs, $t = [].slice, un = [
  "keyword",
  "gray",
  "hex"
], Bt = {};
Object.keys(ve).forEach(function(e) {
  Bt[$t.call(ve[e].labels).sort().join("")] = e;
});
var mt = {};
function ce(e, r) {
  if (!(this instanceof ce))
    return new ce(e, r);
  if (r && r in un && (r = null), r && !(r in ve))
    throw new Error("Unknown model: " + r);
  var t, n;
  if (e == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (e instanceof ce)
    this.model = e.model, this.color = e.color.slice(), this.valpha = e.valpha;
  else if (typeof e == "string") {
    var a = tt.get(e);
    if (a === null)
      throw new Error("Unable to parse color from string: " + e);
    this.model = a.model, n = ve[this.model].channels, this.color = a.value.slice(0, n), this.valpha = typeof a.value[n] == "number" ? a.value[n] : 1;
  } else if (e.length) {
    this.model = r || "rgb", n = ve[this.model].channels;
    var s = $t.call(e, 0, n);
    this.color = qt(s, n), this.valpha = typeof e[n] == "number" ? e[n] : 1;
  } else if (typeof e == "number")
    e &= 16777215, this.model = "rgb", this.color = [
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    var i = Object.keys(e);
    "alpha" in e && (i.splice(i.indexOf("alpha"), 1), this.valpha = typeof e.alpha == "number" ? e.alpha : 0);
    var o = i.sort().join("");
    if (!(o in Bt))
      throw new Error("Unable to parse color from object: " + JSON.stringify(e));
    this.model = Bt[o];
    var c = ve[this.model].labels, d = [];
    for (t = 0; t < c.length; t++)
      d.push(e[c[t]]);
    this.color = qt(d);
  }
  if (mt[this.model])
    for (n = ve[this.model].channels, t = 0; t < n; t++) {
      var f = mt[this.model][t];
      f && (this.color[t] = f(this.color[t]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
ce.prototype = {
  toString: function() {
    return this.string();
  },
  toJSON: function() {
    return this[this.model]();
  },
  string: function(e) {
    var r = this.model in tt.to ? this : this.rgb();
    r = r.round(typeof e == "number" ? e : 1);
    var t = r.valpha === 1 ? r.color : r.color.concat(this.valpha);
    return tt.to[r.model](t);
  },
  percentString: function(e) {
    var r = this.rgb().round(typeof e == "number" ? e : 1), t = r.valpha === 1 ? r.color : r.color.concat(this.valpha);
    return tt.to.rgb.percent(t);
  },
  array: function() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function() {
    for (var e = {}, r = ve[this.model].channels, t = ve[this.model].labels, n = 0; n < r; n++)
      e[t[n]] = this.color[n];
    return this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  unitArray: function() {
    var e = this.rgb().color;
    return e[0] /= 255, e[1] /= 255, e[2] /= 255, this.valpha !== 1 && e.push(this.valpha), e;
  },
  unitObject: function() {
    var e = this.rgb().object();
    return e.r /= 255, e.g /= 255, e.b /= 255, this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  round: function(e) {
    return e = Math.max(e || 0, 0), new ce(this.color.map(gs(e)).concat(this.valpha), this.model);
  },
  alpha: function(e) {
    return arguments.length ? new ce(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
  },
  red: ee("rgb", 0, se(255)),
  green: ee("rgb", 1, se(255)),
  blue: ee("rgb", 2, se(255)),
  hue: ee(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(e) {
    return (e % 360 + 360) % 360;
  }),
  saturationl: ee("hsl", 1, se(100)),
  lightness: ee("hsl", 2, se(100)),
  saturationv: ee("hsv", 1, se(100)),
  value: ee("hsv", 2, se(100)),
  chroma: ee("hcg", 1, se(100)),
  gray: ee("hcg", 2, se(100)),
  white: ee("hwb", 1, se(100)),
  wblack: ee("hwb", 2, se(100)),
  cyan: ee("cmyk", 0, se(100)),
  magenta: ee("cmyk", 1, se(100)),
  yellow: ee("cmyk", 2, se(100)),
  black: ee("cmyk", 3, se(100)),
  x: ee("xyz", 0, se(100)),
  y: ee("xyz", 1, se(100)),
  z: ee("xyz", 2, se(100)),
  l: ee("lab", 0, se(100)),
  a: ee("lab", 1),
  b: ee("lab", 2),
  keyword: function(e) {
    return arguments.length ? new ce(e) : ve[this.model].keyword(this.color);
  },
  hex: function(e) {
    return arguments.length ? new ce(e) : tt.to.hex(this.rgb().round().color);
  },
  rgbNumber: function() {
    var e = this.rgb().color;
    return (e[0] & 255) << 16 | (e[1] & 255) << 8 | e[2] & 255;
  },
  luminosity: function() {
    for (var e = this.rgb().color, r = [], t = 0; t < e.length; t++) {
      var n = e[t] / 255;
      r[t] = n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2];
  },
  contrast: function(e) {
    var r = this.luminosity(), t = e.luminosity();
    return r > t ? (r + 0.05) / (t + 0.05) : (t + 0.05) / (r + 0.05);
  },
  level: function(e) {
    var r = this.contrast(e);
    return r >= 7.1 ? "AAA" : r >= 4.5 ? "AA" : "";
  },
  isDark: function() {
    var e = this.rgb().color, r = (e[0] * 299 + e[1] * 587 + e[2] * 114) / 1e3;
    return r < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  negate: function() {
    for (var e = this.rgb(), r = 0; r < 3; r++)
      e.color[r] = 255 - e.color[r];
    return e;
  },
  lighten: function(e) {
    var r = this.hsl();
    return r.color[2] += r.color[2] * e, r;
  },
  darken: function(e) {
    var r = this.hsl();
    return r.color[2] -= r.color[2] * e, r;
  },
  saturate: function(e) {
    var r = this.hsl();
    return r.color[1] += r.color[1] * e, r;
  },
  desaturate: function(e) {
    var r = this.hsl();
    return r.color[1] -= r.color[1] * e, r;
  },
  whiten: function(e) {
    var r = this.hwb();
    return r.color[1] += r.color[1] * e, r;
  },
  blacken: function(e) {
    var r = this.hwb();
    return r.color[2] += r.color[2] * e, r;
  },
  grayscale: function() {
    var e = this.rgb().color, r = e[0] * 0.3 + e[1] * 0.59 + e[2] * 0.11;
    return ce.rgb(r, r, r);
  },
  fade: function(e) {
    return this.alpha(this.valpha - this.valpha * e);
  },
  opaquer: function(e) {
    return this.alpha(this.valpha + this.valpha * e);
  },
  rotate: function(e) {
    var r = this.hsl(), t = r.color[0];
    return t = (t + e) % 360, t = t < 0 ? 360 + t : t, r.color[0] = t, r;
  },
  mix: function(e, r) {
    if (!e || !e.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
    var t = e.rgb(), n = this.rgb(), a = r === void 0 ? 0.5 : r, s = 2 * a - 1, i = t.alpha() - n.alpha(), o = ((s * i === -1 ? s : (s + i) / (1 + s * i)) + 1) / 2, c = 1 - o;
    return ce.rgb(
      o * t.red() + c * n.red(),
      o * t.green() + c * n.green(),
      o * t.blue() + c * n.blue(),
      t.alpha() * a + n.alpha() * (1 - a)
    );
  }
};
Object.keys(ve).forEach(function(e) {
  if (un.indexOf(e) === -1) {
    var r = ve[e].channels;
    ce.prototype[e] = function() {
      if (this.model === e)
        return new ce(this);
      if (arguments.length)
        return new ce(arguments, e);
      var t = typeof arguments[r] == "number" ? r : this.valpha;
      return new ce(ys(ve[this.model][e].raw(this.color)).concat(t), e);
    }, ce[e] = function(t) {
      return typeof t == "number" && (t = qt($t.call(arguments), r)), new ce(t, e);
    };
  }
});
function vs(e, r) {
  return Number(e.toFixed(r));
}
function gs(e) {
  return function(r) {
    return vs(r, e);
  };
}
function ee(e, r, t) {
  return e = Array.isArray(e) ? e : [e], e.forEach(function(n) {
    (mt[n] || (mt[n] = []))[r] = t;
  }), e = e[0], function(n) {
    var a;
    return arguments.length ? (t && (n = t(n)), a = this[e](), a.color[r] = n, a) : (a = this[e]().color[r], t && (a = t(a)), a);
  };
}
function se(e) {
  return function(r) {
    return Math.max(0, Math.min(e, r));
  };
}
function ys(e) {
  return Array.isArray(e) ? e : [e];
}
function qt(e, r) {
  for (var t = 0; t < r; t++)
    typeof e[t] != "number" && (e[t] = 0);
  return e;
}
var dr = ce, ms = "Expected a function", fr = "__lodash_placeholder__", Ne = 1, Et = 2, ws = 4, Le = 8, st = 16, He = 32, ct = 64, dn = 128, Es = 256, fn = 512, pr = 1 / 0, xs = 9007199254740991, Cs = 17976931348623157e292, hr = 0 / 0, _s = [
  ["ary", dn],
  ["bind", Ne],
  ["bindKey", Et],
  ["curry", Le],
  ["curryRight", st],
  ["flip", fn],
  ["partial", He],
  ["partialRight", ct],
  ["rearg", Es]
], ks = "[object Function]", Ss = "[object GeneratorFunction]", Rs = "[object Symbol]", As = /[\\^$.*+?()[\]{}|]/g, Os = /^\s+|\s+$/g, Ts = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ps = /\{\n\/\* \[wrapped with (.+)\] \*/, js = /,? & /, Fs = /^[-+]0x[0-9a-f]+$/i, Ms = /^0b[01]+$/i, Ds = /^\[object .+?Constructor\]$/, Is = /^0o[0-7]+$/i, Ls = /^(?:0|[1-9]\d*)$/, Ns = parseInt, Bs = typeof ht == "object" && ht && ht.Object === Object && ht, qs = typeof self == "object" && self && self.Object === Object && self, dt = Bs || qs || Function("return this")();
function pn(e, r, t) {
  switch (t.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, t[0]);
    case 2:
      return e.call(r, t[0], t[1]);
    case 3:
      return e.call(r, t[0], t[1], t[2]);
  }
  return e.apply(r, t);
}
function zs(e, r) {
  for (var t = -1, n = e ? e.length : 0; ++t < n && r(e[t], t, e) !== !1; )
    ;
  return e;
}
function Vs(e, r) {
  var t = e ? e.length : 0;
  return !!t && $s(e, r, 0) > -1;
}
function Ws(e, r, t, n) {
  for (var a = e.length, s = t + (n ? 1 : -1); n ? s-- : ++s < a; )
    if (r(e[s], s, e))
      return s;
  return -1;
}
function $s(e, r, t) {
  if (r !== r)
    return Ws(e, Ks, t);
  for (var n = t - 1, a = e.length; ++n < a; )
    if (e[n] === r)
      return n;
  return -1;
}
function Ks(e) {
  return e !== e;
}
function Us(e, r) {
  for (var t = e.length, n = 0; t--; )
    e[t] === r && n++;
  return n;
}
function Ys(e, r) {
  return e == null ? void 0 : e[r];
}
function Hs(e) {
  var r = !1;
  if (e != null && typeof e.toString != "function")
    try {
      r = !!(e + "");
    } catch {
    }
  return r;
}
function hn(e, r) {
  for (var t = -1, n = e.length, a = 0, s = []; ++t < n; ) {
    var i = e[t];
    (i === r || i === fr) && (e[t] = fr, s[a++] = t);
  }
  return s;
}
var Gs = Function.prototype, bn = Object.prototype, Tt = dt["__core-js_shared__"], br = function() {
  var e = /[^.]+$/.exec(Tt && Tt.keys && Tt.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), vn = Gs.toString, Js = bn.hasOwnProperty, gn = bn.toString, Xs = RegExp(
  "^" + vn.call(Js).replace(As, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), Zs = Object.create, wt = Math.max, Qs = Math.min, vr = function() {
  var e = gr(Object, "defineProperty"), r = gr.name;
  return r && r.length > 2 ? e : void 0;
}();
function ei(e) {
  return Xe(e) ? Zs(e) : {};
}
function ti(e) {
  if (!Xe(e) || fi(e))
    return !1;
  var r = vi(e) || Hs(e) ? Xs : Ds;
  return r.test(hi(e));
}
function ri(e, r, t, n) {
  for (var a = -1, s = e.length, i = t.length, o = -1, c = r.length, d = wt(s - i, 0), f = Array(c + d), p = !n; ++o < c; )
    f[o] = r[o];
  for (; ++a < i; )
    (p || a < s) && (f[t[a]] = e[a]);
  for (; d--; )
    f[o++] = e[a++];
  return f;
}
function ni(e, r, t, n) {
  for (var a = -1, s = e.length, i = -1, o = t.length, c = -1, d = r.length, f = wt(s - o, 0), p = Array(f + d), w = !n; ++a < f; )
    p[a] = e[a];
  for (var m = a; ++c < d; )
    p[m + c] = r[c];
  for (; ++i < o; )
    (w || a < s) && (p[m + t[i]] = e[a++]);
  return p;
}
function ai(e, r) {
  var t = -1, n = e.length;
  for (r || (r = Array(n)); ++t < n; )
    r[t] = e[t];
  return r;
}
function si(e, r, t) {
  var n = r & Ne, a = lt(e);
  function s() {
    var i = this && this !== dt && this instanceof s ? a : e;
    return i.apply(n ? t : this, arguments);
  }
  return s;
}
function lt(e) {
  return function() {
    var r = arguments;
    switch (r.length) {
      case 0:
        return new e();
      case 1:
        return new e(r[0]);
      case 2:
        return new e(r[0], r[1]);
      case 3:
        return new e(r[0], r[1], r[2]);
      case 4:
        return new e(r[0], r[1], r[2], r[3]);
      case 5:
        return new e(r[0], r[1], r[2], r[3], r[4]);
      case 6:
        return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
      case 7:
        return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
    }
    var t = ei(e.prototype), n = e.apply(t, r);
    return Xe(n) ? n : t;
  };
}
function ii(e, r, t) {
  var n = lt(e);
  function a() {
    for (var s = arguments.length, i = Array(s), o = s, c = mn(a); o--; )
      i[o] = arguments[o];
    var d = s < 3 && i[0] !== c && i[s - 1] !== c ? [] : hn(i, c);
    if (s -= d.length, s < t)
      return yn(
        e,
        r,
        Kt,
        a.placeholder,
        void 0,
        i,
        d,
        void 0,
        void 0,
        t - s
      );
    var f = this && this !== dt && this instanceof a ? n : e;
    return pn(f, this, i);
  }
  return a;
}
function Kt(e, r, t, n, a, s, i, o, c, d) {
  var f = r & dn, p = r & Ne, w = r & Et, m = r & (Le | st), A = r & fn, O = w ? void 0 : lt(e);
  function k() {
    for (var W = arguments.length, F = Array(W), J = W; J--; )
      F[J] = arguments[J];
    if (m)
      var X = mn(k), b = Us(F, X);
    if (n && (F = ri(F, n, a, m)), s && (F = ni(F, s, i, m)), W -= b, m && W < d) {
      var te = hn(F, X);
      return yn(
        e,
        r,
        Kt,
        k.placeholder,
        t,
        F,
        te,
        o,
        c,
        d - W
      );
    }
    var Z = p ? t : this, ne = w ? Z[e] : e;
    return W = F.length, o ? F = pi(F, o) : A && W > 1 && F.reverse(), f && c < W && (F.length = c), this && this !== dt && this instanceof k && (ne = O || lt(ne)), ne.apply(Z, F);
  }
  return k;
}
function oi(e, r, t, n) {
  var a = r & Ne, s = lt(e);
  function i() {
    for (var o = -1, c = arguments.length, d = -1, f = n.length, p = Array(f + c), w = this && this !== dt && this instanceof i ? s : e; ++d < f; )
      p[d] = n[d];
    for (; c--; )
      p[d++] = arguments[++o];
    return pn(w, a ? t : this, p);
  }
  return i;
}
function yn(e, r, t, n, a, s, i, o, c, d) {
  var f = r & Le, p = f ? i : void 0, w = f ? void 0 : i, m = f ? s : void 0, A = f ? void 0 : s;
  r |= f ? He : ct, r &= ~(f ? ct : He), r & ws || (r &= ~(Ne | Et));
  var O = t(e, r, a, m, p, A, w, o, c, d);
  return O.placeholder = n, wn(O, e, r);
}
function ci(e, r, t, n, a, s, i, o) {
  var c = r & Et;
  if (!c && typeof e != "function")
    throw new TypeError(ms);
  var d = n ? n.length : 0;
  if (d || (r &= ~(He | ct), n = a = void 0), i = i === void 0 ? i : wt(yr(i), 0), o = o === void 0 ? o : yr(o), d -= a ? a.length : 0, r & ct) {
    var f = n, p = a;
    n = a = void 0;
  }
  var w = [
    e,
    r,
    t,
    n,
    a,
    f,
    p,
    s,
    i,
    o
  ];
  if (e = w[0], r = w[1], t = w[2], n = w[3], a = w[4], o = w[9] = w[9] == null ? c ? 0 : e.length : wt(w[9] - d, 0), !o && r & (Le | st) && (r &= ~(Le | st)), !r || r == Ne)
    var m = si(e, r, t);
  else
    r == Le || r == st ? m = ii(e, r, o) : (r == He || r == (Ne | He)) && !a.length ? m = oi(e, r, t, n) : m = Kt.apply(void 0, w);
  return wn(m, e, r);
}
function mn(e) {
  var r = e;
  return r.placeholder;
}
function gr(e, r) {
  var t = Ys(e, r);
  return ti(t) ? t : void 0;
}
function li(e) {
  var r = e.match(Ps);
  return r ? r[1].split(js) : [];
}
function ui(e, r) {
  var t = r.length, n = t - 1;
  return r[n] = (t > 1 ? "& " : "") + r[n], r = r.join(t > 2 ? ", " : " "), e.replace(Ts, `{
/* [wrapped with ` + r + `] */
`);
}
function di(e, r) {
  return r = r == null ? xs : r, !!r && (typeof e == "number" || Ls.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
function fi(e) {
  return !!br && br in e;
}
function pi(e, r) {
  for (var t = e.length, n = Qs(r.length, t), a = ai(e); n--; ) {
    var s = r[n];
    e[n] = di(s, t) ? a[s] : void 0;
  }
  return e;
}
var wn = vr ? function(e, r, t) {
  var n = r + "";
  return vr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ei(ui(n, bi(li(n), t)))
  });
} : xi;
function hi(e) {
  if (e != null) {
    try {
      return vn.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function bi(e, r) {
  return zs(_s, function(t) {
    var n = "_." + t[0];
    r & t[1] && !Vs(e, n) && e.push(n);
  }), e.sort();
}
function Ut(e, r, t) {
  r = t ? void 0 : r;
  var n = ci(e, Le, void 0, void 0, void 0, void 0, void 0, r);
  return n.placeholder = Ut.placeholder, n;
}
function vi(e) {
  var r = Xe(e) ? gn.call(e) : "";
  return r == ks || r == Ss;
}
function Xe(e) {
  var r = typeof e;
  return !!e && (r == "object" || r == "function");
}
function gi(e) {
  return !!e && typeof e == "object";
}
function yi(e) {
  return typeof e == "symbol" || gi(e) && gn.call(e) == Rs;
}
function mi(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = wi(e), e === pr || e === -pr) {
    var r = e < 0 ? -1 : 1;
    return r * Cs;
  }
  return e === e ? e : 0;
}
function yr(e) {
  var r = mi(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
function wi(e) {
  if (typeof e == "number")
    return e;
  if (yi(e))
    return hr;
  if (Xe(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Xe(r) ? r + "" : r;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Os, "");
  var t = Ms.test(e);
  return t || Is.test(e) ? Ns(e.slice(2), t ? 2 : 8) : Fs.test(e) ? hr : +e;
}
function Ei(e) {
  return function() {
    return e;
  };
}
function xi(e) {
  return e;
}
Ut.placeholder = {};
var mr = Ut;
function Ci(e) {
  var r = e[0], t = e[1], n = e[2], a, s, i;
  return a = r * 1 + t * 0 + n * 1.13983, s = r * 1 + t * -0.39465 + n * -0.5806, i = r * 1 + t * 2.02311 + n * 0, a = Math.min(Math.max(0, a), 1), s = Math.min(Math.max(0, s), 1), i = Math.min(Math.max(0, i), 1), [a * 255, s * 255, i * 255];
}
function _i(e) {
  var r = e[0] / 255, t = e[1] / 255, n = e[2] / 255, a = r * 0.299 + t * 0.587 + n * 0.114, s = r * -0.14713 + t * -0.28886 + n * 0.436, i = r * 0.615 + t * -0.51499 + n * -0.10001;
  return [a, s, i];
}
function wr(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Se(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? wr(Object(t), !0).forEach(function(n) {
      la(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wr(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
var En = nn, Er = Object.keys(En), ki = function(r) {
  return r < 0.25 ? 1 : r < 0.5 ? 0.9 - r : 1.1 - r;
}, Si = function(r) {
  var t = dr(r), n = _i(t.array()), a = rn(n, 3), s = a[0], i = a[1], o = a[2], c = [ki(s), i, o], d = Ci(c);
  return dr.rgb(d).hex();
}, $e = function(r) {
  return function(t) {
    return {
      className: [t.className, r.className].filter(Boolean).join(" "),
      style: Se(Se({}, t.style || {}), r.style || {})
    };
  };
}, Ri = function(r, t) {
  if (r === void 0)
    return t;
  if (t === void 0)
    return r;
  var n = ot(r), a = ot(t);
  switch (n) {
    case "string":
      switch (a) {
        case "string":
          return [t, r].filter(Boolean).join(" ");
        case "object":
          return $e({
            className: r,
            style: t
          });
        case "function":
          return function(s) {
            for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
              o[c - 1] = arguments[c];
            return $e({
              className: r
            })(t.apply(void 0, [s].concat(o)));
          };
      }
      break;
    case "object":
      switch (a) {
        case "string":
          return $e({
            className: t,
            style: r
          });
        case "object":
          return Se(Se({}, t), r);
        case "function":
          return function(s) {
            for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
              o[c - 1] = arguments[c];
            return $e({
              style: r
            })(t.apply(void 0, [s].concat(o)));
          };
      }
      break;
    case "function":
      switch (a) {
        case "string":
          return function(s) {
            for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
              o[c - 1] = arguments[c];
            return r.apply(void 0, [$e(s)({
              className: t
            })].concat(o));
          };
        case "object":
          return function(s) {
            for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
              o[c - 1] = arguments[c];
            return r.apply(void 0, [$e(s)({
              style: t
            })].concat(o));
          };
        case "function":
          return function(s) {
            for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
              o[c - 1] = arguments[c];
            return r.apply(void 0, [t.apply(void 0, [s].concat(o))].concat(o));
          };
      }
  }
}, Ai = function(r, t) {
  var n = Object.keys(t);
  for (var a in r)
    n.indexOf(a) === -1 && n.push(a);
  return n.reduce(function(s, i) {
    return s[i] = Ri(r[i], t[i]), s;
  }, {});
}, Oi = function(r, t) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    a[s - 2] = arguments[s];
  if (t === null)
    return r;
  Array.isArray(t) || (t = [t]);
  var i = t.map(function(c) {
    return r[c];
  }).filter(Boolean), o = i.reduce(function(c, d) {
    return typeof d == "string" ? c.className = [c.className, d].filter(Boolean).join(" ") : ot(d) === "object" ? c.style = Se(Se({}, c.style), d) : typeof d == "function" && (c = Se(Se({}, c), d.apply(void 0, [c].concat(a)))), c;
  }, {
    className: "",
    style: {}
  });
  return o.className || delete o.className, Object.keys(o.style).length === 0 && delete o.style, o;
}, Ti = function(r) {
  return Object.keys(r).reduce(function(t, n) {
    return t[n] = /^base/.test(n) ? Si(r[n]) : n === "scheme" ? r[n] + ":inverted" : r[n], t;
  }, {});
}, Pi = mr(function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = r.defaultBase16, a = n === void 0 ? En : n, s = r.base16Themes, i = s === void 0 ? null : s, o = Fi(t, i);
  o && (t = Se(Se({}, o), t));
  for (var c = Er.reduce(function(O, k) {
    return O[k] = t[k] || a[k], O;
  }, {}), d = Object.keys(t).reduce(function(O, k) {
    return Er.indexOf(k) === -1 && (O[k] = t[k]), O;
  }, {}), f = e(c), p = Ai(d, f), w = arguments.length, m = new Array(w > 3 ? w - 3 : 0), A = 3; A < w; A++)
    m[A - 3] = arguments[A];
  return mr(Oi, 2).apply(void 0, [p].concat(m));
}, 3), ji = function(r) {
  return !!r.extend;
}, Fi = function(r, t) {
  if (r && ji(r) && r.extend && (r = r.extend), typeof r == "string") {
    var n = r.split(":"), a = rn(n, 2), s = a[0], i = a[1];
    t ? r = t[s] : r = Ja[s], i === "inverted" && (r = Ti(r));
  }
  return r && Object.prototype.hasOwnProperty.call(r, "base00") ? r : void 0;
};
const Mi = {
  scheme: "rjv-default",
  author: "mac gainor",
  base00: "rgba(0, 0, 0, 0)",
  base01: "rgb(245, 245, 245)",
  base02: "rgb(235, 235, 235)",
  base03: "#93a1a1",
  base04: "rgba(0, 0, 0, 0.3)",
  base05: "#586e75",
  base06: "#073642",
  base07: "#002b36",
  base08: "#d33682",
  base09: "#cb4b16",
  base0A: "#dc322f",
  base0B: "#859900",
  base0C: "#6c71c4",
  base0D: "#586e75",
  base0E: "#2aa198",
  base0F: "#268bd2"
}, Di = {
  scheme: "rjv-grey",
  author: "mac gainor",
  base00: "rgba(1, 1, 1, 0)",
  base01: "rgba(1, 1, 1, 0.1)",
  base02: "rgba(0, 0, 0, 0.2)",
  base03: "rgba(1, 1, 1, 0.3)",
  base04: "rgba(0, 0, 0, 0.4)",
  base05: "rgba(1, 1, 1, 0.5)",
  base06: "rgba(1, 1, 1, 0.6)",
  base07: "rgba(1, 1, 1, 0.7)",
  base08: "rgba(1, 1, 1, 0.8)",
  base09: "rgba(1, 1, 1, 0.8)",
  base0A: "rgba(1, 1, 1, 0.8)",
  base0B: "rgba(1, 1, 1, 0.8)",
  base0C: "rgba(1, 1, 1, 0.8)",
  base0D: "rgba(1, 1, 1, 0.8)",
  base0E: "rgba(1, 1, 1, 0.8)",
  base0F: "rgba(1, 1, 1, 0.8)"
}, v = {
  white: "#fff",
  black: "#000",
  transparent: "rgba(1, 1, 1, 0)",
  globalFontFamily: "monospace",
  globalCursor: "default",
  indentBlockWidth: "5px",
  braceFontWeight: "bold",
  braceCursor: "pointer",
  ellipsisFontSize: "18px",
  ellipsisLineHeight: "10px",
  ellipsisCursor: "pointer",
  keyMargin: "0px 5px",
  keyLetterSpacing: "0.5px",
  keyFontStyle: "none",
  keyBorderRadius: "3px",
  keyColonWeight: "bold",
  keyVerticalAlign: "top",
  keyOpacity: "0.85",
  keyOpacityHover: "1",
  keyValPaddingTop: "3px",
  keyValPaddingBottom: "3px",
  keyValPaddingRight: "5px",
  keyValBorderLeft: "1px solid",
  keyValBorderHover: "2px solid",
  keyValPaddingHover: "3px 5px 3px 4px",
  pushedContentMarginLeft: "6px",
  variableValuePaddingRight: "6px",
  nullFontSize: "11px",
  nullFontWeight: "bold",
  nullPadding: "1px 2px",
  nullBorderRadius: "3px",
  nanFontSize: "11px",
  nanFontWeight: "bold",
  nanPadding: "1px 2px",
  nanBorderRadius: "3px",
  undefinedFontSize: "11px",
  undefinedFontWeight: "bold",
  undefinedPadding: "1px 2px",
  undefinedBorderRadius: "3px",
  dataTypeFontSize: "11px",
  dataTypeMarginRight: "4px",
  datatypeOpacity: "0.8",
  objectSizeBorderRadius: "3px",
  objectSizeFontStyle: "italic",
  objectSizeMargin: "0px 6px 0px 0px",
  clipboardCursor: "pointer",
  clipboardCheckMarginLeft: "-12px",
  metaDataPadding: "0px 0px 0px 10px",
  arrayGroupMetaPadding: "0px 0px 0px 4px",
  iconContainerWidth: "17px",
  tooltipPadding: "4px",
  editInputMinWidth: "130px",
  editInputBorderRadius: "2px",
  editInputPadding: "5px",
  editInputMarginRight: "4px",
  editInputFontFamily: "monospace",
  iconCursor: "pointer",
  iconFontSize: "15px",
  iconPaddingRight: "1px",
  dateValueMarginLeft: "2px",
  iconMarginRight: "3px",
  detectedRowPaddingTop: "3px",
  addKeyCoverBackground: "rgba(255, 255, 255, 0.3)",
  addKeyCoverPosition: "absolute",
  addKeyCoverPositionPx: "0px",
  addKeyModalWidth: "200px",
  addKeyModalMargin: "auto",
  addKeyModalPadding: "10px",
  addKeyModalRadius: "3px"
}, Ii = (e) => ({
  backgroundColor: e.base00,
  ellipsisColor: e.base09,
  braceColor: e.base07,
  expandedIcon: e.base0D,
  collapsedIcon: e.base0E,
  keyColor: e.base07,
  arrayKeyColor: e.base0C,
  objectSize: e.base04,
  copyToClipboard: e.base0F,
  copyToClipboardCheck: e.base0D,
  objectBorder: e.base02,
  dataTypes: {
    boolean: e.base0E,
    date: e.base0D,
    float: e.base0B,
    function: e.base0D,
    integer: e.base0F,
    string: e.base09,
    nan: e.base08,
    null: e.base0A,
    undefined: e.base05,
    regexp: e.base0A,
    background: e.base02
  },
  editVariable: {
    editIcon: e.base0E,
    cancelIcon: e.base09,
    removeIcon: e.base09,
    addIcon: e.base0E,
    checkIcon: e.base0E,
    background: e.base01,
    color: e.base0A,
    border: e.base07
  },
  addKeyModal: {
    background: e.base05,
    border: e.base04,
    color: e.base0A,
    labelColor: e.base01
  },
  validationFailure: {
    background: e.base09,
    iconColor: e.base01,
    fontColor: e.base01
  }
}), Li = (e) => {
  const r = Ii(e);
  return {
    "app-container": {
      fontFamily: v.globalFontFamily,
      cursor: v.globalCursor,
      backgroundColor: r.backgroundColor,
      position: "relative"
    },
    ellipsis: {
      display: "inline-block",
      color: r.ellipsisColor,
      fontSize: v.ellipsisFontSize,
      lineHeight: v.ellipsisLineHeight,
      cursor: v.ellipsisCursor
    },
    "brace-row": {
      display: "inline-block",
      cursor: "pointer"
    },
    brace: {
      display: "inline-block",
      cursor: v.braceCursor,
      fontWeight: v.braceFontWeight,
      color: r.braceColor
    },
    "expanded-icon": {
      color: r.expandedIcon
    },
    "collapsed-icon": {
      color: r.collapsedIcon
    },
    colon: {
      display: "inline-block",
      margin: v.keyMargin,
      color: r.keyColor,
      verticalAlign: "top"
    },
    objectKeyVal: (t, n) => ({
      style: {
        paddingTop: v.keyValPaddingTop,
        paddingRight: v.keyValPaddingRight,
        paddingBottom: v.keyValPaddingBottom,
        borderLeft: v.keyValBorderLeft + " " + r.objectBorder,
        ":hover": {
          paddingLeft: n.paddingLeft - 1 + "px",
          borderLeft: v.keyValBorderHover + " " + r.objectBorder
        },
        ...n
      }
    }),
    "object-key-val-no-border": {
      padding: v.keyValPadding
    },
    "pushed-content": {
      marginLeft: v.pushedContentMarginLeft
    },
    variableValue: (t, n) => ({
      style: {
        display: "inline-block",
        paddingRight: v.variableValuePaddingRight,
        position: "relative",
        ...n
      }
    }),
    "object-name": {
      display: "inline-block",
      color: r.keyColor,
      letterSpacing: v.keyLetterSpacing,
      fontStyle: v.keyFontStyle,
      verticalAlign: v.keyVerticalAlign,
      opacity: v.keyOpacity,
      ":hover": {
        opacity: v.keyOpacityHover
      }
    },
    "array-key": {
      display: "inline-block",
      color: r.arrayKeyColor,
      letterSpacing: v.keyLetterSpacing,
      fontStyle: v.keyFontStyle,
      verticalAlign: v.keyVerticalAlign,
      opacity: v.keyOpacity,
      ":hover": {
        opacity: v.keyOpacityHover
      }
    },
    "object-size": {
      color: r.objectSize,
      borderRadius: v.objectSizeBorderRadius,
      fontStyle: v.objectSizeFontStyle,
      margin: v.objectSizeMargin,
      cursor: "default"
    },
    "data-type-label": {
      fontSize: v.dataTypeFontSize,
      marginRight: v.dataTypeMarginRight,
      opacity: v.datatypeOpacity
    },
    boolean: {
      display: "inline-block",
      color: r.dataTypes.boolean
    },
    date: {
      display: "inline-block",
      color: r.dataTypes.date
    },
    "date-value": {
      marginLeft: v.dateValueMarginLeft
    },
    float: {
      display: "inline-block",
      color: r.dataTypes.float
    },
    function: {
      display: "inline-block",
      color: r.dataTypes.function,
      cursor: "pointer",
      whiteSpace: "pre-line"
    },
    "function-value": {
      fontStyle: "italic"
    },
    integer: {
      display: "inline-block",
      color: r.dataTypes.integer
    },
    string: {
      display: "inline-block",
      color: r.dataTypes.string
    },
    nan: {
      display: "inline-block",
      color: r.dataTypes.nan,
      fontSize: v.nanFontSize,
      fontWeight: v.nanFontWeight,
      backgroundColor: r.dataTypes.background,
      padding: v.nanPadding,
      borderRadius: v.nanBorderRadius
    },
    null: {
      display: "inline-block",
      color: r.dataTypes.null,
      fontSize: v.nullFontSize,
      fontWeight: v.nullFontWeight,
      backgroundColor: r.dataTypes.background,
      padding: v.nullPadding,
      borderRadius: v.nullBorderRadius
    },
    undefined: {
      display: "inline-block",
      color: r.dataTypes.undefined,
      fontSize: v.undefinedFontSize,
      padding: v.undefinedPadding,
      borderRadius: v.undefinedBorderRadius,
      backgroundColor: r.dataTypes.background
    },
    regexp: {
      display: "inline-block",
      color: r.dataTypes.regexp
    },
    "copy-to-clipboard": {
      cursor: v.clipboardCursor
    },
    "copy-icon": {
      color: r.copyToClipboard,
      fontSize: v.iconFontSize,
      marginRight: v.iconMarginRight,
      verticalAlign: "top"
    },
    "copy-icon-copied": {
      color: r.copyToClipboardCheck,
      marginLeft: v.clipboardCheckMarginLeft
    },
    "array-group-meta-data": {
      display: "inline-block",
      padding: v.arrayGroupMetaPadding
    },
    "object-meta-data": {
      display: "inline-block",
      padding: v.metaDataPadding
    },
    "icon-container": {
      display: "inline-block",
      width: v.iconContainerWidth
    },
    tooltip: {
      padding: v.tooltipPadding
    },
    removeVarIcon: {
      verticalAlign: "top",
      display: "inline-block",
      color: r.editVariable.removeIcon,
      cursor: v.iconCursor,
      fontSize: v.iconFontSize,
      marginRight: v.iconMarginRight
    },
    addVarIcon: {
      verticalAlign: "top",
      display: "inline-block",
      color: r.editVariable.addIcon,
      cursor: v.iconCursor,
      fontSize: v.iconFontSize,
      marginRight: v.iconMarginRight
    },
    editVarIcon: {
      verticalAlign: "top",
      display: "inline-block",
      color: r.editVariable.editIcon,
      cursor: v.iconCursor,
      fontSize: v.iconFontSize,
      marginRight: v.iconMarginRight
    },
    "edit-icon-container": {
      display: "inline-block",
      verticalAlign: "top"
    },
    "check-icon": {
      display: "inline-block",
      cursor: v.iconCursor,
      color: r.editVariable.checkIcon,
      fontSize: v.iconFontSize,
      paddingRight: v.iconPaddingRight
    },
    "cancel-icon": {
      display: "inline-block",
      cursor: v.iconCursor,
      color: r.editVariable.cancelIcon,
      fontSize: v.iconFontSize,
      paddingRight: v.iconPaddingRight
    },
    "edit-input": {
      display: "inline-block",
      minWidth: v.editInputMinWidth,
      borderRadius: v.editInputBorderRadius,
      backgroundColor: r.editVariable.background,
      color: r.editVariable.color,
      padding: v.editInputPadding,
      marginRight: v.editInputMarginRight,
      fontFamily: v.editInputFontFamily
    },
    "detected-row": {
      paddingTop: v.detectedRowPaddingTop
    },
    "key-modal-request": {
      position: v.addKeyCoverPosition,
      top: v.addKeyCoverPositionPx,
      left: v.addKeyCoverPositionPx,
      right: v.addKeyCoverPositionPx,
      bottom: v.addKeyCoverPositionPx,
      backgroundColor: v.addKeyCoverBackground
    },
    "key-modal": {
      width: v.addKeyModalWidth,
      backgroundColor: r.addKeyModal.background,
      marginLeft: v.addKeyModalMargin,
      marginRight: v.addKeyModalMargin,
      padding: v.addKeyModalPadding,
      borderRadius: v.addKeyModalRadius,
      marginTop: "15px",
      position: "relative"
    },
    "key-modal-label": {
      color: r.addKeyModal.labelColor,
      marginLeft: "2px",
      marginBottom: "5px",
      fontSize: "11px"
    },
    "key-modal-input-container": {
      overflow: "hidden"
    },
    "key-modal-input": {
      width: "100%",
      padding: "3px 6px",
      fontFamily: "monospace",
      color: r.addKeyModal.color,
      border: "none",
      boxSizing: "border-box",
      borderRadius: "2px"
    },
    "key-modal-cancel": {
      backgroundColor: r.editVariable.removeIcon,
      position: "absolute",
      top: "0px",
      right: "0px",
      borderRadius: "0px 3px 0px 3px",
      cursor: "pointer"
    },
    "key-modal-cancel-icon": {
      color: r.addKeyModal.labelColor,
      fontSize: v.iconFontSize,
      transform: "rotate(45deg)"
    },
    "key-modal-submit": {
      color: r.editVariable.addIcon,
      fontSize: v.iconFontSize,
      position: "absolute",
      right: "2px",
      top: "3px",
      cursor: "pointer"
    },
    "function-ellipsis": {
      display: "inline-block",
      color: r.ellipsisColor,
      fontSize: v.ellipsisFontSize,
      lineHeight: v.ellipsisLineHeight,
      cursor: v.ellipsisCursor
    },
    "validation-failure": {
      float: "right",
      padding: "3px 6px",
      borderRadius: "2px",
      cursor: "pointer",
      color: r.validationFailure.fontColor,
      backgroundColor: r.validationFailure.background
    },
    "validation-failure-label": {
      marginRight: "6px"
    },
    "validation-failure-clear": {
      position: "relative",
      verticalAlign: "top",
      cursor: "pointer",
      color: r.validationFailure.iconColor,
      fontSize: v.iconFontSize,
      transform: "rotate(45deg)"
    }
  };
}, Ni = (e) => {
  let r = Mi;
  return (e === !1 || e === "none") && (r = Di), Pi(Li, { defaultBase16: r })(
    e
  );
};
function y(e, r, t) {
  return e || console.error("theme has not been set"), Ni(e)(r, t);
}
function ye(e) {
  let r = Bi(e);
  return r === "number" && (isNaN(e) ? r = "nan" : (e | 0) != e ? r = "float" : r = "integer"), r;
}
function Bi(e) {
  return {}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function qi(e) {
  const r = [
    "base00",
    "base01",
    "base02",
    "base03",
    "base04",
    "base05",
    "base06",
    "base07",
    "base08",
    "base09",
    "base0A",
    "base0B",
    "base0C",
    "base0D",
    "base0E",
    "base0F"
  ];
  if (ye(e) === "object") {
    for (let t = 0; t < r.length; t++)
      if (!(r[t] in e))
        return !1;
    return !0;
  }
  return !1;
}
var Yt = { exports: {} }, Ge = typeof Reflect == "object" ? Reflect : null, xr = Ge && typeof Ge.apply == "function" ? Ge.apply : function(r, t, n) {
  return Function.prototype.apply.call(r, t, n);
}, gt;
Ge && typeof Ge.ownKeys == "function" ? gt = Ge.ownKeys : Object.getOwnPropertySymbols ? gt = function(r) {
  return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
} : gt = function(r) {
  return Object.getOwnPropertyNames(r);
};
function zi(e) {
  console && console.warn && console.warn(e);
}
var xn = Number.isNaN || function(r) {
  return r !== r;
};
function H() {
  H.init.call(this);
}
Yt.exports = H;
Yt.exports.once = Ki;
H.EventEmitter = H;
H.prototype._events = void 0;
H.prototype._eventsCount = 0;
H.prototype._maxListeners = void 0;
var Cr = 10;
function xt(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(H, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Cr;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || xn(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    Cr = e;
  }
});
H.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
H.prototype.setMaxListeners = function(r) {
  if (typeof r != "number" || r < 0 || xn(r))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + r + ".");
  return this._maxListeners = r, this;
};
function Cn(e) {
  return e._maxListeners === void 0 ? H.defaultMaxListeners : e._maxListeners;
}
H.prototype.getMaxListeners = function() {
  return Cn(this);
};
H.prototype.emit = function(r) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t.push(arguments[n]);
  var a = r === "error", s = this._events;
  if (s !== void 0)
    a = a && s.error === void 0;
  else if (!a)
    return !1;
  if (a) {
    var i;
    if (t.length > 0 && (i = t[0]), i instanceof Error)
      throw i;
    var o = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
    throw o.context = i, o;
  }
  var c = s[r];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    xr(c, this, t);
  else
    for (var d = c.length, f = An(c, d), n = 0; n < d; ++n)
      xr(f[n], this, t);
  return !0;
};
function _n(e, r, t, n) {
  var a, s, i;
  if (xt(t), s = e._events, s === void 0 ? (s = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (s.newListener !== void 0 && (e.emit(
    "newListener",
    r,
    t.listener ? t.listener : t
  ), s = e._events), i = s[r]), i === void 0)
    i = s[r] = t, ++e._eventsCount;
  else if (typeof i == "function" ? i = s[r] = n ? [t, i] : [i, t] : n ? i.unshift(t) : i.push(t), a = Cn(e), a > 0 && i.length > a && !i.warned) {
    i.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + i.length + " " + String(r) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = r, o.count = i.length, zi(o);
  }
  return e;
}
H.prototype.addListener = function(r, t) {
  return _n(this, r, t, !1);
};
H.prototype.on = H.prototype.addListener;
H.prototype.prependListener = function(r, t) {
  return _n(this, r, t, !0);
};
function Vi() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function kn(e, r, t) {
  var n = { fired: !1, wrapFn: void 0, target: e, type: r, listener: t }, a = Vi.bind(n);
  return a.listener = t, n.wrapFn = a, a;
}
H.prototype.once = function(r, t) {
  return xt(t), this.on(r, kn(this, r, t)), this;
};
H.prototype.prependOnceListener = function(r, t) {
  return xt(t), this.prependListener(r, kn(this, r, t)), this;
};
H.prototype.removeListener = function(r, t) {
  var n, a, s, i, o;
  if (xt(t), a = this._events, a === void 0)
    return this;
  if (n = a[r], n === void 0)
    return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete a[r], a.removeListener && this.emit("removeListener", r, n.listener || t));
  else if (typeof n != "function") {
    for (s = -1, i = n.length - 1; i >= 0; i--)
      if (n[i] === t || n[i].listener === t) {
        o = n[i].listener, s = i;
        break;
      }
    if (s < 0)
      return this;
    s === 0 ? n.shift() : Wi(n, s), n.length === 1 && (a[r] = n[0]), a.removeListener !== void 0 && this.emit("removeListener", r, o || t);
  }
  return this;
};
H.prototype.off = H.prototype.removeListener;
H.prototype.removeAllListeners = function(r) {
  var t, n, a;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[r] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[r]), this;
  if (arguments.length === 0) {
    var s = Object.keys(n), i;
    for (a = 0; a < s.length; ++a)
      i = s[a], i !== "removeListener" && this.removeAllListeners(i);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[r], typeof t == "function")
    this.removeListener(r, t);
  else if (t !== void 0)
    for (a = t.length - 1; a >= 0; a--)
      this.removeListener(r, t[a]);
  return this;
};
function Sn(e, r, t) {
  var n = e._events;
  if (n === void 0)
    return [];
  var a = n[r];
  return a === void 0 ? [] : typeof a == "function" ? t ? [a.listener || a] : [a] : t ? $i(a) : An(a, a.length);
}
H.prototype.listeners = function(r) {
  return Sn(this, r, !0);
};
H.prototype.rawListeners = function(r) {
  return Sn(this, r, !1);
};
H.listenerCount = function(e, r) {
  return typeof e.listenerCount == "function" ? e.listenerCount(r) : Rn.call(e, r);
};
H.prototype.listenerCount = Rn;
function Rn(e) {
  var r = this._events;
  if (r !== void 0) {
    var t = r[e];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
H.prototype.eventNames = function() {
  return this._eventsCount > 0 ? gt(this._events) : [];
};
function An(e, r) {
  for (var t = new Array(r), n = 0; n < r; ++n)
    t[n] = e[n];
  return t;
}
function Wi(e, r) {
  for (; r + 1 < e.length; r++)
    e[r] = e[r + 1];
  e.pop();
}
function $i(e) {
  for (var r = new Array(e.length), t = 0; t < r.length; ++t)
    r[t] = e[t].listener || e[t];
  return r;
}
function Ki(e, r) {
  return new Promise(function(t, n) {
    function a(i) {
      e.removeListener(r, s), n(i);
    }
    function s() {
      typeof e.removeListener == "function" && e.removeListener("error", a), t([].slice.call(arguments));
    }
    On(e, r, s, { once: !0 }), r !== "error" && Ui(e, a, { once: !0 });
  });
}
function Ui(e, r, t) {
  typeof e.on == "function" && On(e, "error", r, t);
}
function On(e, r, t, n) {
  if (typeof e.on == "function")
    n.once ? e.once(r, t) : e.on(r, t);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(r, function a(s) {
      n.once && e.removeEventListener(r, a), t(s);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var Yi = process.env.NODE_ENV !== "production" ? function(e) {
  if (e === void 0)
    throw new Error("invariant(...): Second argument must be a string.");
} : function(e) {
};
function Hi(e, r) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), a = 2; a < t; a++)
    n[a - 2] = arguments[a];
  if (Yi(r), !e) {
    var s;
    if (r === void 0)
      s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i = 0;
      s = new Error(r.replace(/%s/g, function() {
        return String(n[i++]);
      })), s.name = "Invariant Violation";
    }
    throw s.framesToPop = 1, s;
  }
}
var Gi = Hi;
function Ke(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
var _e = Gi, Ji = "ID_", Xi = /* @__PURE__ */ function() {
  function e() {
    Ke(this, "_callbacks", void 0), Ke(this, "_isDispatching", void 0), Ke(this, "_isHandled", void 0), Ke(this, "_isPending", void 0), Ke(this, "_lastID", void 0), Ke(this, "_pendingPayload", void 0), this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
  }
  var r = e.prototype;
  return r.register = function(n) {
    var a = Ji + this._lastID++;
    return this._callbacks[a] = n, a;
  }, r.unregister = function(n) {
    this._callbacks[n] || (process.env.NODE_ENV !== "production" ? _e(!1, "Dispatcher.unregister(...): `%s` does not map to a registered callback.", n) : _e(!1)), delete this._callbacks[n];
  }, r.waitFor = function(n) {
    this._isDispatching || (process.env.NODE_ENV !== "production" ? _e(!1, "Dispatcher.waitFor(...): Must be invoked while dispatching.") : _e(!1));
    for (var a = 0; a < n.length; a++) {
      var s = n[a];
      if (this._isPending[s]) {
        this._isHandled[s] || (process.env.NODE_ENV !== "production" ? _e(!1, "Dispatcher.waitFor(...): Circular dependency detected while waiting for `%s`.", s) : _e(!1));
        continue;
      }
      this._callbacks[s] || (process.env.NODE_ENV !== "production" ? _e(!1, "Dispatcher.waitFor(...): `%s` does not map to a registered callback.", s) : _e(!1)), this._invokeCallback(s);
    }
  }, r.dispatch = function(n) {
    this._isDispatching && (process.env.NODE_ENV !== "production" ? _e(!1, "Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.") : _e(!1)), this._startDispatching(n);
    try {
      for (var a in this._callbacks)
        this._isPending[a] || this._invokeCallback(a);
    } finally {
      this._stopDispatching();
    }
  }, r.isDispatching = function() {
    return this._isDispatching;
  }, r._invokeCallback = function(n) {
    this._isPending[n] = !0, this._callbacks[n](this._pendingPayload), this._isHandled[n] = !0;
  }, r._startDispatching = function(n) {
    for (var a in this._callbacks)
      this._isPending[a] = !1, this._isHandled[a] = !1;
    this._pendingPayload = n, this._isDispatching = !0;
  }, r._stopDispatching = function() {
    delete this._pendingPayload, this._isDispatching = !1;
  }, e;
}(), Zi = Xi, Qi = Zi;
const Re = new Qi();
class eo extends Yt.exports.EventEmitter {
  constructor() {
    super(...arguments);
    R(this, "objects", {});
    R(this, "set", (t, n, a, s) => {
      this.objects[t] === void 0 && (this.objects[t] = {}), this.objects[t][n] === void 0 && (this.objects[t][n] = {}), this.objects[t][n][a] = s;
    });
    R(this, "get", (t, n, a, s) => this.objects[t] === void 0 || this.objects[t][n] === void 0 || this.objects[t][n][a] == null ? s : this.objects[t][n][a]);
    R(this, "handleAction", (t) => {
      const { rjvId: n, data: a, name: s } = t;
      switch (s) {
        case "RESET":
          this.emit("reset-" + n);
          break;
        case "VARIABLE_UPDATED":
          t.data.updated_src = this.updateSrc(n, a), this.set(n, "action", "variable-update", {
            ...a,
            type: "variable-edited"
          }), this.emit("variable-update-" + n);
          break;
        case "VARIABLE_REMOVED":
          t.data.updated_src = this.updateSrc(n, a), this.set(n, "action", "variable-update", {
            ...a,
            type: "variable-removed"
          }), this.emit("variable-update-" + n);
          break;
        case "VARIABLE_ADDED":
          t.data.updated_src = this.updateSrc(n, a), this.set(n, "action", "variable-update", {
            ...a,
            type: "variable-added"
          }), this.emit("variable-update-" + n);
          break;
        case "ADD_VARIABLE_KEY_REQUEST":
          this.set(n, "action", "new-key-request", a), this.emit("add-key-request-" + n);
          break;
      }
    });
    R(this, "updateSrc", (t, n) => {
      const {
        name: a,
        namespace: s,
        new_value: i,
        existing_value: o,
        variable_removed: c
      } = n;
      s.shift();
      const d = this.get(t, "global", "src");
      let f = this.deepCopy(d, [...s]), p = f;
      for (const w of s)
        p = p[w];
      return c ? ye(p) == "array" ? p.splice(a, 1) : delete p[a] : a !== null ? p[a] = i : f = i, this.set(t, "global", "src", f), f;
    });
    R(this, "deepCopy", (t, n) => {
      const a = ye(t);
      let s;
      const i = n.shift();
      return a == "array" ? s = [...t] : a == "object" && (s = { ...t }), i !== void 0 && (s[i] = this.deepCopy(t[i], n)), s;
    });
  }
}
const ue = new eo();
Re.register(ue.handleAction.bind(ue));
var Ht = { exports: {} }, Qe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function to() {
  if (_r)
    return Qe;
  _r = 1;
  var e = q, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(o, c, d) {
    var f, p = {}, w = null, m = null;
    d !== void 0 && (w = "" + d), c.key !== void 0 && (w = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (f in c)
      n.call(c, f) && !s.hasOwnProperty(f) && (p[f] = c[f]);
    if (o && o.defaultProps)
      for (f in c = o.defaultProps, c)
        p[f] === void 0 && (p[f] = c[f]);
    return { $$typeof: r, type: o, key: w, ref: m, props: p, _owner: a.current };
  }
  return Qe.Fragment = t, Qe.jsx = i, Qe.jsxs = i, Qe;
}
var et = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr;
function ro() {
  return kr || (kr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = q, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), A = Symbol.iterator, O = "@@iterator";
    function k(l) {
      if (l === null || typeof l != "object")
        return null;
      var h = A && l[A] || l[O];
      return typeof h == "function" ? h : null;
    }
    var W = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(l) {
      {
        for (var h = arguments.length, E = new Array(h > 1 ? h - 1 : 0), S = 1; S < h; S++)
          E[S - 1] = arguments[S];
        J("error", l, E);
      }
    }
    function J(l, h, E) {
      {
        var S = W.ReactDebugCurrentFrame, K = S.getStackAddendum();
        K !== "" && (h += "%s", E = E.concat([K]));
        var G = E.map(function(V) {
          return String(V);
        });
        G.unshift("Warning: " + h), Function.prototype.apply.call(console[l], console, G);
      }
    }
    var X = !1, b = !1, te = !1, Z = !1, ne = !1, Te;
    Te = Symbol.for("react.module.reference");
    function Fe(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === n || l === s || ne || l === a || l === d || l === f || Z || l === m || X || b || te || typeof l == "object" && l !== null && (l.$$typeof === w || l.$$typeof === p || l.$$typeof === i || l.$$typeof === o || l.$$typeof === c || l.$$typeof === Te || l.getModuleId !== void 0));
    }
    function Pe(l, h, E) {
      var S = l.displayName;
      if (S)
        return S;
      var K = h.displayName || h.name || "";
      return K !== "" ? E + "(" + K + ")" : E;
    }
    function Ae(l) {
      return l.displayName || "Context";
    }
    function ie(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case o:
            var h = l;
            return Ae(h) + ".Consumer";
          case i:
            var E = l;
            return Ae(E._context) + ".Provider";
          case c:
            return Pe(l, l.render, "ForwardRef");
          case p:
            var S = l.displayName || null;
            return S !== null ? S : ie(l.type) || "Memo";
          case w: {
            var K = l, G = K._payload, V = K._init;
            try {
              return ie(V(G));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, xe = 0, de, Ce, Me, qe, g, C, D;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function T() {
      {
        if (xe === 0) {
          de = console.log, Ce = console.info, Me = console.warn, qe = console.error, g = console.group, C = console.groupCollapsed, D = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        xe++;
      }
    }
    function z() {
      {
        if (xe--, xe === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, l, {
              value: de
            }),
            info: Q({}, l, {
              value: Ce
            }),
            warn: Q({}, l, {
              value: Me
            }),
            error: Q({}, l, {
              value: qe
            }),
            group: Q({}, l, {
              value: g
            }),
            groupCollapsed: Q({}, l, {
              value: C
            }),
            groupEnd: Q({}, l, {
              value: D
            })
          });
        }
        xe < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var P = W.ReactCurrentDispatcher, j;
    function I(l, h, E) {
      {
        if (j === void 0)
          try {
            throw Error();
          } catch (K) {
            var S = K.stack.trim().match(/\n( *(at )?)/);
            j = S && S[1] || "";
          }
        return `
` + j + l;
      }
    }
    var $ = !1, L;
    {
      var le = typeof WeakMap == "function" ? WeakMap : Map;
      L = new le();
    }
    function x(l, h) {
      if (!l || $)
        return "";
      {
        var E = L.get(l);
        if (E !== void 0)
          return E;
      }
      var S;
      $ = !0;
      var K = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var G;
      G = P.current, P.current = null, T();
      try {
        if (h) {
          var V = function() {
            throw Error();
          };
          if (Object.defineProperty(V.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(V, []);
            } catch (Oe) {
              S = Oe;
            }
            Reflect.construct(l, [], V);
          } else {
            try {
              V.call();
            } catch (Oe) {
              S = Oe;
            }
            l.call(V.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Oe) {
            S = Oe;
          }
          l();
        }
      } catch (Oe) {
        if (Oe && S && typeof Oe.stack == "string") {
          for (var N = Oe.stack.split(`
`), fe = S.stack.split(`
`), re = N.length - 1, ae = fe.length - 1; re >= 1 && ae >= 0 && N[re] !== fe[ae]; )
            ae--;
          for (; re >= 1 && ae >= 0; re--, ae--)
            if (N[re] !== fe[ae]) {
              if (re !== 1 || ae !== 1)
                do
                  if (re--, ae--, ae < 0 || N[re] !== fe[ae]) {
                    var we = `
` + N[re].replace(" at new ", " at ");
                    return l.displayName && we.includes("<anonymous>") && (we = we.replace("<anonymous>", l.displayName)), typeof l == "function" && L.set(l, we), we;
                  }
                while (re >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        $ = !1, P.current = G, z(), Error.prepareStackTrace = K;
      }
      var We = l ? l.displayName || l.name : "", cr = We ? I(We) : "";
      return typeof l == "function" && L.set(l, cr), cr;
    }
    function me(l, h, E) {
      return x(l, !1);
    }
    function ze(l) {
      var h = l.prototype;
      return !!(h && h.isReactComponent);
    }
    function De(l, h, E) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return x(l, ze(l));
      if (typeof l == "string")
        return I(l);
      switch (l) {
        case d:
          return I("Suspense");
        case f:
          return I("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case c:
            return me(l.render);
          case p:
            return De(l.type, h, E);
          case w: {
            var S = l, K = S._payload, G = S._init;
            try {
              return De(G(K), h, E);
            } catch {
            }
          }
        }
      return "";
    }
    var ft = Object.prototype.hasOwnProperty, Jt = {}, Xt = W.ReactDebugCurrentFrame;
    function pt(l) {
      if (l) {
        var h = l._owner, E = De(l.type, l._source, h ? h.type : null);
        Xt.setExtraStackFrame(E);
      } else
        Xt.setExtraStackFrame(null);
    }
    function qn(l, h, E, S, K) {
      {
        var G = Function.call.bind(ft);
        for (var V in l)
          if (G(l, V)) {
            var N = void 0;
            try {
              if (typeof l[V] != "function") {
                var fe = Error((S || "React class") + ": " + E + " type `" + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[V] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw fe.name = "Invariant Violation", fe;
              }
              N = l[V](h, V, S, E, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (re) {
              N = re;
            }
            N && !(N instanceof Error) && (pt(K), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", E, V, typeof N), pt(null)), N instanceof Error && !(N.message in Jt) && (Jt[N.message] = !0, pt(K), F("Failed %s type: %s", E, N.message), pt(null));
          }
      }
    }
    var zn = Array.isArray;
    function Ct(l) {
      return zn(l);
    }
    function Vn(l) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, E = h && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return E;
      }
    }
    function Wn(l) {
      try {
        return Zt(l), !1;
      } catch {
        return !0;
      }
    }
    function Zt(l) {
      return "" + l;
    }
    function Qt(l) {
      if (Wn(l))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Vn(l)), Zt(l);
    }
    var Ze = W.ReactCurrentOwner, $n = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, er, tr, _t;
    _t = {};
    function Kn(l) {
      if (ft.call(l, "ref")) {
        var h = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function Un(l) {
      if (ft.call(l, "key")) {
        var h = Object.getOwnPropertyDescriptor(l, "key").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function Yn(l, h) {
      if (typeof l.ref == "string" && Ze.current && h && Ze.current.stateNode !== h) {
        var E = ie(Ze.current.type);
        _t[E] || (F('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ie(Ze.current.type), l.ref), _t[E] = !0);
      }
    }
    function Hn(l, h) {
      {
        var E = function() {
          er || (er = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        E.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: E,
          configurable: !0
        });
      }
    }
    function Gn(l, h) {
      {
        var E = function() {
          tr || (tr = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        E.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: E,
          configurable: !0
        });
      }
    }
    var Jn = function(l, h, E, S, K, G, V) {
      var N = {
        $$typeof: r,
        type: l,
        key: h,
        ref: E,
        props: V,
        _owner: G
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: K
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Xn(l, h, E, S, K) {
      {
        var G, V = {}, N = null, fe = null;
        E !== void 0 && (Qt(E), N = "" + E), Un(h) && (Qt(h.key), N = "" + h.key), Kn(h) && (fe = h.ref, Yn(h, K));
        for (G in h)
          ft.call(h, G) && !$n.hasOwnProperty(G) && (V[G] = h[G]);
        if (l && l.defaultProps) {
          var re = l.defaultProps;
          for (G in re)
            V[G] === void 0 && (V[G] = re[G]);
        }
        if (N || fe) {
          var ae = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          N && Hn(V, ae), fe && Gn(V, ae);
        }
        return Jn(l, N, fe, K, S, Ze.current, V);
      }
    }
    var kt = W.ReactCurrentOwner, rr = W.ReactDebugCurrentFrame;
    function Ve(l) {
      if (l) {
        var h = l._owner, E = De(l.type, l._source, h ? h.type : null);
        rr.setExtraStackFrame(E);
      } else
        rr.setExtraStackFrame(null);
    }
    var St;
    St = !1;
    function Rt(l) {
      return typeof l == "object" && l !== null && l.$$typeof === r;
    }
    function nr() {
      {
        if (kt.current) {
          var l = ie(kt.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function Zn(l) {
      {
        if (l !== void 0) {
          var h = l.fileName.replace(/^.*[\\\/]/, ""), E = l.lineNumber;
          return `

Check your code at ` + h + ":" + E + ".";
        }
        return "";
      }
    }
    var ar = {};
    function Qn(l) {
      {
        var h = nr();
        if (!h) {
          var E = typeof l == "string" ? l : l.displayName || l.name;
          E && (h = `

Check the top-level render call using <` + E + ">.");
        }
        return h;
      }
    }
    function sr(l, h) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var E = Qn(h);
        if (ar[E])
          return;
        ar[E] = !0;
        var S = "";
        l && l._owner && l._owner !== kt.current && (S = " It was passed a child from " + ie(l._owner.type) + "."), Ve(l), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', E, S), Ve(null);
      }
    }
    function ir(l, h) {
      {
        if (typeof l != "object")
          return;
        if (Ct(l))
          for (var E = 0; E < l.length; E++) {
            var S = l[E];
            Rt(S) && sr(S, h);
          }
        else if (Rt(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var K = k(l);
          if (typeof K == "function" && K !== l.entries)
            for (var G = K.call(l), V; !(V = G.next()).done; )
              Rt(V.value) && sr(V.value, h);
        }
      }
    }
    function ea(l) {
      {
        var h = l.type;
        if (h == null || typeof h == "string")
          return;
        var E;
        if (typeof h == "function")
          E = h.propTypes;
        else if (typeof h == "object" && (h.$$typeof === c || h.$$typeof === p))
          E = h.propTypes;
        else
          return;
        if (E) {
          var S = ie(h);
          qn(E, l.props, "prop", S, l);
        } else if (h.PropTypes !== void 0 && !St) {
          St = !0;
          var K = ie(h);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
        }
        typeof h.getDefaultProps == "function" && !h.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ta(l) {
      {
        for (var h = Object.keys(l.props), E = 0; E < h.length; E++) {
          var S = h[E];
          if (S !== "children" && S !== "key") {
            Ve(l), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), Ve(null);
            break;
          }
        }
        l.ref !== null && (Ve(l), F("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    function or(l, h, E, S, K, G) {
      {
        var V = Fe(l);
        if (!V) {
          var N = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var fe = Zn(K);
          fe ? N += fe : N += nr();
          var re;
          l === null ? re = "null" : Ct(l) ? re = "array" : l !== void 0 && l.$$typeof === r ? (re = "<" + (ie(l.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : re = typeof l, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", re, N);
        }
        var ae = Xn(l, h, E, K, G);
        if (ae == null)
          return ae;
        if (V) {
          var we = h.children;
          if (we !== void 0)
            if (S)
              if (Ct(we)) {
                for (var We = 0; We < we.length; We++)
                  ir(we[We], l);
                Object.freeze && Object.freeze(we);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ir(we, l);
        }
        return l === n ? ta(ae) : ea(ae), ae;
      }
    }
    function ra(l, h, E) {
      return or(l, h, E, !0);
    }
    function na(l, h, E) {
      return or(l, h, E, !1);
    }
    var aa = na, sa = ra;
    et.Fragment = n, et.jsx = aa, et.jsxs = sa;
  }()), et;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = to() : e.exports = ro();
})(Ht);
const u = Ht.exports.jsx, B = Ht.exports.jsxs;
function Tn(e) {
  const {
    parent_type: r,
    namespace: t,
    quotesOnKeys: n,
    theme: a,
    jsvRoot: s,
    name: i,
    displayArrayKey: o
  } = e, c = e.name ? e.name : "";
  return s && (i === !1 || i === null) ? /* @__PURE__ */ u("span", {}) : r == "array" ? o ? /* @__PURE__ */ nt("span", {
    ...y(a, "array-key"),
    key: t
  }, /* @__PURE__ */ u("span", {
    className: "array-key",
    children: c
  }), /* @__PURE__ */ u("span", {
    ...y(a, "colon"),
    children: ":"
  })) : /* @__PURE__ */ u("span", {}) : /* @__PURE__ */ nt("span", {
    ...y(a, "object-name"),
    key: t
  }, /* @__PURE__ */ B("span", {
    className: "object-key",
    children: [n && /* @__PURE__ */ u("span", {
      style: {
        verticalAlign: "top"
      },
      children: '"'
    }), /* @__PURE__ */ u("span", {
      children: c
    }), n && /* @__PURE__ */ u("span", {
      style: {
        verticalAlign: "top"
      },
      children: '"'
    })]
  }), /* @__PURE__ */ u("span", {
    ...y(a, "colon"),
    children: ":"
  }));
}
const no = "#000000";
class ao extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 24 24",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("path", {
          d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"
        })
      })
    });
  }
}
class so extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 24 24",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("path", {
          d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
        })
      })
    });
  }
}
class io extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r, a = Ee(t).style;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        fill: a.color,
        width: a.height,
        height: a.width,
        style: a,
        viewBox: "0 0 1792 1792",
        children: /* @__PURE__ */ u("path", {
          d: "M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
        })
      })
    });
  }
}
class oo extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r, a = Ee(t).style;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        fill: a.color,
        width: a.height,
        height: a.width,
        style: a,
        viewBox: "0 0 1792 1792",
        children: /* @__PURE__ */ u("path", {
          d: "M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
        })
      })
    });
  }
}
class co extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        style: {
          ...Ee(t).style,
          paddingLeft: "2px",
          verticalAlign: "top"
        },
        viewBox: "0 0 15 15",
        fill: "currentColor",
        children: /* @__PURE__ */ u("path", {
          d: "M0 14l6-6-6-6z"
        })
      })
    });
  }
}
class lo extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        style: {
          ...Ee(t).style,
          paddingLeft: "2px",
          verticalAlign: "top"
        },
        viewBox: "0 0 15 15",
        fill: "currentColor",
        children: /* @__PURE__ */ u("path", {
          d: "M0 5l6 6 6-6z"
        })
      })
    });
  }
}
class Sr extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"
          })
        })
      })
    });
  }
}
class zt extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
          })
        })
      })
    });
  }
}
class uo extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
          })
        })
      })
    });
  }
}
class Pn extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"
          })
        })
      })
    });
  }
}
class fo extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"
          })
        })
      })
    });
  }
}
class Vt extends q.PureComponent {
  render() {
    const {
      props: r
    } = this, {
      style: t,
      ...n
    } = r;
    return /* @__PURE__ */ u("span", {
      ...n,
      children: /* @__PURE__ */ u("svg", {
        ...Ee(t),
        viewBox: "0 0 40 40",
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ u("g", {
          children: /* @__PURE__ */ u("path", {
            d: "m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
          })
        })
      })
    });
  }
}
function Ee(e) {
  return e || (e = {}), {
    style: {
      verticalAlign: "middle",
      ...e,
      color: e.color ? e.color : no,
      height: "1em",
      width: "1em"
    }
  };
}
function jn(e) {
  const {
    theme: r,
    iconStyle: t
  } = e;
  switch (t) {
    case "triangle":
      return /* @__PURE__ */ u(lo, {
        ...y(r, "expanded-icon"),
        class: "expanded-icon"
      });
    case "square":
      return /* @__PURE__ */ u(io, {
        ...y(r, "expanded-icon"),
        class: "expanded-icon"
      });
    default:
      return /* @__PURE__ */ u(ao, {
        ...y(r, "expanded-icon"),
        class: "expanded-icon"
      });
  }
}
function Fn(e) {
  const {
    theme: r,
    iconStyle: t
  } = e;
  switch (t) {
    case "triangle":
      return /* @__PURE__ */ u(co, {
        ...y(r, "collapsed-icon"),
        class: "collapsed-icon"
      });
    case "square":
      return /* @__PURE__ */ u(oo, {
        ...y(r, "collapsed-icon"),
        class: "collapsed-icon"
      });
    default:
      return /* @__PURE__ */ u(so, {
        ...y(r, "collapsed-icon"),
        class: "collapsed-icon"
      });
  }
}
function it() {
  return it = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, it.apply(this, arguments);
}
function po(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var oe = { exports: {} }, Pt = { exports: {} }, U = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function ho() {
  if (Rr)
    return U;
  Rr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function J(b) {
    if (typeof b == "object" && b !== null) {
      var te = b.$$typeof;
      switch (te) {
        case r:
          switch (b = b.type, b) {
            case c:
            case d:
            case n:
            case s:
            case a:
            case p:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case o:
                case f:
                case A:
                case m:
                case i:
                  return b;
                default:
                  return te;
              }
          }
        case t:
          return te;
      }
    }
  }
  function X(b) {
    return J(b) === d;
  }
  return U.AsyncMode = c, U.ConcurrentMode = d, U.ContextConsumer = o, U.ContextProvider = i, U.Element = r, U.ForwardRef = f, U.Fragment = n, U.Lazy = A, U.Memo = m, U.Portal = t, U.Profiler = s, U.StrictMode = a, U.Suspense = p, U.isAsyncMode = function(b) {
    return X(b) || J(b) === c;
  }, U.isConcurrentMode = X, U.isContextConsumer = function(b) {
    return J(b) === o;
  }, U.isContextProvider = function(b) {
    return J(b) === i;
  }, U.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === r;
  }, U.isForwardRef = function(b) {
    return J(b) === f;
  }, U.isFragment = function(b) {
    return J(b) === n;
  }, U.isLazy = function(b) {
    return J(b) === A;
  }, U.isMemo = function(b) {
    return J(b) === m;
  }, U.isPortal = function(b) {
    return J(b) === t;
  }, U.isProfiler = function(b) {
    return J(b) === s;
  }, U.isStrictMode = function(b) {
    return J(b) === a;
  }, U.isSuspense = function(b) {
    return J(b) === p;
  }, U.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === d || b === s || b === a || b === p || b === w || typeof b == "object" && b !== null && (b.$$typeof === A || b.$$typeof === m || b.$$typeof === i || b.$$typeof === o || b.$$typeof === f || b.$$typeof === k || b.$$typeof === W || b.$$typeof === F || b.$$typeof === O);
  }, U.typeOf = J, U;
}
var Y = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function bo() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function J(x) {
      return typeof x == "string" || typeof x == "function" || x === n || x === d || x === s || x === a || x === p || x === w || typeof x == "object" && x !== null && (x.$$typeof === A || x.$$typeof === m || x.$$typeof === i || x.$$typeof === o || x.$$typeof === f || x.$$typeof === k || x.$$typeof === W || x.$$typeof === F || x.$$typeof === O);
    }
    function X(x) {
      if (typeof x == "object" && x !== null) {
        var me = x.$$typeof;
        switch (me) {
          case r:
            var ze = x.type;
            switch (ze) {
              case c:
              case d:
              case n:
              case s:
              case a:
              case p:
                return ze;
              default:
                var De = ze && ze.$$typeof;
                switch (De) {
                  case o:
                  case f:
                  case A:
                  case m:
                  case i:
                    return De;
                  default:
                    return me;
                }
            }
          case t:
            return me;
        }
      }
    }
    var b = c, te = d, Z = o, ne = i, Te = r, Fe = f, Pe = n, Ae = A, ie = m, Q = t, xe = s, de = a, Ce = p, Me = !1;
    function qe(x) {
      return Me || (Me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), g(x) || X(x) === c;
    }
    function g(x) {
      return X(x) === d;
    }
    function C(x) {
      return X(x) === o;
    }
    function D(x) {
      return X(x) === i;
    }
    function M(x) {
      return typeof x == "object" && x !== null && x.$$typeof === r;
    }
    function T(x) {
      return X(x) === f;
    }
    function z(x) {
      return X(x) === n;
    }
    function P(x) {
      return X(x) === A;
    }
    function j(x) {
      return X(x) === m;
    }
    function I(x) {
      return X(x) === t;
    }
    function $(x) {
      return X(x) === s;
    }
    function L(x) {
      return X(x) === a;
    }
    function le(x) {
      return X(x) === p;
    }
    Y.AsyncMode = b, Y.ConcurrentMode = te, Y.ContextConsumer = Z, Y.ContextProvider = ne, Y.Element = Te, Y.ForwardRef = Fe, Y.Fragment = Pe, Y.Lazy = Ae, Y.Memo = ie, Y.Portal = Q, Y.Profiler = xe, Y.StrictMode = de, Y.Suspense = Ce, Y.isAsyncMode = qe, Y.isConcurrentMode = g, Y.isContextConsumer = C, Y.isContextProvider = D, Y.isElement = M, Y.isForwardRef = T, Y.isFragment = z, Y.isLazy = P, Y.isMemo = j, Y.isPortal = I, Y.isProfiler = $, Y.isStrictMode = L, Y.isSuspense = le, Y.isValidElementType = J, Y.typeOf = X;
  }()), Y;
}
var Or;
function Mn() {
  return Or || (Or = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = ho() : e.exports = bo();
  }(Pt)), Pt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var jt, Tr;
function vo() {
  if (Tr)
    return jt;
  Tr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, o = 0; o < 10; o++)
        i["_" + String.fromCharCode(o)] = o;
      var c = Object.getOwnPropertyNames(i).map(function(f) {
        return i[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return jt = a() ? Object.assign : function(s, i) {
    for (var o, c = n(s), d, f = 1; f < arguments.length; f++) {
      o = Object(arguments[f]);
      for (var p in o)
        r.call(o, p) && (c[p] = o[p]);
      if (e) {
        d = e(o);
        for (var w = 0; w < d.length; w++)
          t.call(o, d[w]) && (c[d[w]] = o[d[w]]);
      }
    }
    return c;
  }, jt;
}
var Ft, Pr;
function Gt() {
  if (Pr)
    return Ft;
  Pr = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ft = e, Ft;
}
var Mt, jr;
function Dn() {
  return jr || (jr = 1, Mt = Function.call.bind(Object.prototype.hasOwnProperty)), Mt;
}
var Dt, Fr;
function go() {
  if (Fr)
    return Dt;
  Fr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Gt(), t = {}, n = Dn();
    e = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(s, i, o, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in s)
        if (n(s, f)) {
          var p;
          try {
            if (typeof s[f] != "function") {
              var w = Error(
                (c || "React class") + ": " + o + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            p = s[f](i, f, c, o, null, r);
          } catch (A) {
            p = A;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + o + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in t)) {
            t[p.message] = !0;
            var m = d ? d() : "";
            e(
              "Failed " + o + " type: " + p.message + (m != null ? m : "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Dt = a, Dt;
}
var It, Mr;
function yo() {
  if (Mr)
    return It;
  Mr = 1;
  var e = Mn(), r = vo(), t = Gt(), n = Dn(), a = go(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(o) {
    var c = "Warning: " + o;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return It = function(o, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p(g) {
      var C = g && (d && g[d] || g[f]);
      if (typeof C == "function")
        return C;
    }
    var w = "<<anonymous>>", m = {
      array: W("array"),
      bigint: W("bigint"),
      bool: W("boolean"),
      func: W("function"),
      number: W("number"),
      object: W("object"),
      string: W("string"),
      symbol: W("symbol"),
      any: F(),
      arrayOf: J,
      element: X(),
      elementType: b(),
      instanceOf: te,
      node: Fe(),
      objectOf: ne,
      oneOf: Z,
      oneOfType: Te,
      shape: Ae,
      exact: ie
    };
    function A(g, C) {
      return g === C ? g !== 0 || 1 / g === 1 / C : g !== g && C !== C;
    }
    function O(g, C) {
      this.message = g, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function k(g) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, D = 0;
      function M(z, P, j, I, $, L, le) {
        if (I = I || w, L = L || j, le !== t) {
          if (c) {
            var x = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw x.name = "Invariant Violation", x;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var me = I + ":" + j;
            !C[me] && D < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + L + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[me] = !0, D++);
          }
        }
        return P[j] == null ? z ? P[j] === null ? new O("The " + $ + " `" + L + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new O("The " + $ + " `" + L + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : g(P, j, I, $, L);
      }
      var T = M.bind(null, !1);
      return T.isRequired = M.bind(null, !0), T;
    }
    function W(g) {
      function C(D, M, T, z, P, j) {
        var I = D[M], $ = de(I);
        if ($ !== g) {
          var L = Ce(I);
          return new O(
            "Invalid " + z + " `" + P + "` of type " + ("`" + L + "` supplied to `" + T + "`, expected ") + ("`" + g + "`."),
            { expectedType: g }
          );
        }
        return null;
      }
      return k(C);
    }
    function F() {
      return k(i);
    }
    function J(g) {
      function C(D, M, T, z, P) {
        if (typeof g != "function")
          return new O("Property `" + P + "` of component `" + T + "` has invalid PropType notation inside arrayOf.");
        var j = D[M];
        if (!Array.isArray(j)) {
          var I = de(j);
          return new O("Invalid " + z + " `" + P + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected an array."));
        }
        for (var $ = 0; $ < j.length; $++) {
          var L = g(j, $, T, z, P + "[" + $ + "]", t);
          if (L instanceof Error)
            return L;
        }
        return null;
      }
      return k(C);
    }
    function X() {
      function g(C, D, M, T, z) {
        var P = C[D];
        if (!o(P)) {
          var j = de(P);
          return new O("Invalid " + T + " `" + z + "` of type " + ("`" + j + "` supplied to `" + M + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(g);
    }
    function b() {
      function g(C, D, M, T, z) {
        var P = C[D];
        if (!e.isValidElementType(P)) {
          var j = de(P);
          return new O("Invalid " + T + " `" + z + "` of type " + ("`" + j + "` supplied to `" + M + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(g);
    }
    function te(g) {
      function C(D, M, T, z, P) {
        if (!(D[M] instanceof g)) {
          var j = g.name || w, I = qe(D[M]);
          return new O("Invalid " + z + " `" + P + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected ") + ("instance of `" + j + "`."));
        }
        return null;
      }
      return k(C);
    }
    function Z(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function C(D, M, T, z, P) {
        for (var j = D[M], I = 0; I < g.length; I++)
          if (A(j, g[I]))
            return null;
        var $ = JSON.stringify(g, function(le, x) {
          var me = Ce(x);
          return me === "symbol" ? String(x) : x;
        });
        return new O("Invalid " + z + " `" + P + "` of value `" + String(j) + "` " + ("supplied to `" + T + "`, expected one of " + $ + "."));
      }
      return k(C);
    }
    function ne(g) {
      function C(D, M, T, z, P) {
        if (typeof g != "function")
          return new O("Property `" + P + "` of component `" + T + "` has invalid PropType notation inside objectOf.");
        var j = D[M], I = de(j);
        if (I !== "object")
          return new O("Invalid " + z + " `" + P + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected an object."));
        for (var $ in j)
          if (n(j, $)) {
            var L = g(j, $, T, z, P + "." + $, t);
            if (L instanceof Error)
              return L;
          }
        return null;
      }
      return k(C);
    }
    function Te(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var C = 0; C < g.length; C++) {
        var D = g[C];
        if (typeof D != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Me(D) + " at index " + C + "."
          ), i;
      }
      function M(T, z, P, j, I) {
        for (var $ = [], L = 0; L < g.length; L++) {
          var le = g[L], x = le(T, z, P, j, I, t);
          if (x == null)
            return null;
          x.data && n(x.data, "expectedType") && $.push(x.data.expectedType);
        }
        var me = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new O("Invalid " + j + " `" + I + "` supplied to " + ("`" + P + "`" + me + "."));
      }
      return k(M);
    }
    function Fe() {
      function g(C, D, M, T, z) {
        return Q(C[D]) ? null : new O("Invalid " + T + " `" + z + "` supplied to " + ("`" + M + "`, expected a ReactNode."));
      }
      return k(g);
    }
    function Pe(g, C, D, M, T) {
      return new O(
        (g || "React class") + ": " + C + " type `" + D + "." + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + T + "`."
      );
    }
    function Ae(g) {
      function C(D, M, T, z, P) {
        var j = D[M], I = de(j);
        if (I !== "object")
          return new O("Invalid " + z + " `" + P + "` of type `" + I + "` " + ("supplied to `" + T + "`, expected `object`."));
        for (var $ in g) {
          var L = g[$];
          if (typeof L != "function")
            return Pe(T, z, P, $, Ce(L));
          var le = L(j, $, T, z, P + "." + $, t);
          if (le)
            return le;
        }
        return null;
      }
      return k(C);
    }
    function ie(g) {
      function C(D, M, T, z, P) {
        var j = D[M], I = de(j);
        if (I !== "object")
          return new O("Invalid " + z + " `" + P + "` of type `" + I + "` " + ("supplied to `" + T + "`, expected `object`."));
        var $ = r({}, D[M], g);
        for (var L in $) {
          var le = g[L];
          if (n(g, L) && typeof le != "function")
            return Pe(T, z, P, L, Ce(le));
          if (!le)
            return new O(
              "Invalid " + z + " `" + P + "` key `" + L + "` supplied to `" + T + "`.\nBad object: " + JSON.stringify(D[M], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(g), null, "  ")
            );
          var x = le(j, L, T, z, P + "." + L, t);
          if (x)
            return x;
        }
        return null;
      }
      return k(C);
    }
    function Q(g) {
      switch (typeof g) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !g;
        case "object":
          if (Array.isArray(g))
            return g.every(Q);
          if (g === null || o(g))
            return !0;
          var C = p(g);
          if (C) {
            var D = C.call(g), M;
            if (C !== g.entries) {
              for (; !(M = D.next()).done; )
                if (!Q(M.value))
                  return !1;
            } else
              for (; !(M = D.next()).done; ) {
                var T = M.value;
                if (T && !Q(T[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function xe(g, C) {
      return g === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function de(g) {
      var C = typeof g;
      return Array.isArray(g) ? "array" : g instanceof RegExp ? "object" : xe(C, g) ? "symbol" : C;
    }
    function Ce(g) {
      if (typeof g > "u" || g === null)
        return "" + g;
      var C = de(g);
      if (C === "object") {
        if (g instanceof Date)
          return "date";
        if (g instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function Me(g) {
      var C = Ce(g);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function qe(g) {
      return !g.constructor || !g.constructor.name ? w : g.constructor.name;
    }
    return m.checkPropTypes = a, m.resetWarningCache = a.resetWarningCache, m.PropTypes = m, m;
  }, It;
}
var Lt, Dr;
function mo() {
  if (Dr)
    return Lt;
  Dr = 1;
  var e = Gt();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Lt = function() {
    function n(i, o, c, d, f, p) {
      if (p !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var s = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return s.PropTypes = s, s;
  }, Lt;
}
if (process.env.NODE_ENV !== "production") {
  var wo = Mn(), Eo = !0;
  oe.exports = yo()(wo.isElement, Eo);
} else
  oe.exports = mo()();
function xo(e, r = 166) {
  let t;
  function n(...a) {
    const s = () => {
      e.apply(this, a);
    };
    clearTimeout(t), t = setTimeout(s, r);
  }
  return n.clear = () => {
    clearTimeout(t);
  }, n;
}
function Co(e) {
  return e && e.ownerDocument || document;
}
function Ir(e) {
  return Co(e).defaultView || window;
}
function Lr(e, r) {
  typeof e == "function" ? e(r) : e && (e.current = r);
}
const _o = typeof window < "u" ? he.useLayoutEffect : he.useEffect, ko = _o;
function So(e, r) {
  return he.useMemo(() => e == null && r == null ? null : (t) => {
    Lr(e, t), Lr(r, t);
  }, [e, r]);
}
const Ro = ["onChange", "maxRows", "minRows", "style", "value"];
function vt(e, r) {
  return parseInt(e[r], 10) || 0;
}
const Ao = {
  shadow: {
    visibility: "hidden",
    position: "absolute",
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    transform: "translateZ(0)"
  }
};
function Nr(e) {
  return e == null || Object.keys(e).length === 0;
}
const In = /* @__PURE__ */ he.forwardRef(function(r, t) {
  const {
    onChange: n,
    maxRows: a,
    minRows: s = 1,
    style: i,
    value: o
  } = r, c = po(r, Ro), {
    current: d
  } = he.useRef(o != null), f = he.useRef(null), p = So(t, f), w = he.useRef(null), m = he.useRef(0), [A, O] = he.useState({}), k = he.useCallback(() => {
    const b = f.current, Z = Ir(b).getComputedStyle(b);
    if (Z.width === "0px")
      return {};
    const ne = w.current;
    ne.style.width = Z.width, ne.value = b.value || r.placeholder || "x", ne.value.slice(-1) === `
` && (ne.value += " ");
    const Te = Z["box-sizing"], Fe = vt(Z, "padding-bottom") + vt(Z, "padding-top"), Pe = vt(Z, "border-bottom-width") + vt(Z, "border-top-width"), Ae = ne.scrollHeight;
    ne.value = "x";
    const ie = ne.scrollHeight;
    let Q = Ae;
    s && (Q = Math.max(Number(s) * ie, Q)), a && (Q = Math.min(Number(a) * ie, Q)), Q = Math.max(Q, ie);
    const xe = Q + (Te === "border-box" ? Fe + Pe : 0), de = Math.abs(Q - Ae) <= 1;
    return {
      outerHeightStyle: xe,
      overflow: de
    };
  }, [a, s, r.placeholder]), W = (b, te) => {
    const {
      outerHeightStyle: Z,
      overflow: ne
    } = te;
    return m.current < 20 && (Z > 0 && Math.abs((b.outerHeightStyle || 0) - Z) > 1 || b.overflow !== ne) ? (m.current += 1, {
      overflow: ne,
      outerHeightStyle: Z
    }) : (process.env.NODE_ENV !== "production" && m.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), b);
  }, F = he.useCallback(() => {
    const b = k();
    Nr(b) || O((te) => W(te, b));
  }, [k]), J = () => {
    const b = k();
    Nr(b) || ca(() => {
      O((te) => W(te, b));
    });
  };
  he.useEffect(() => {
    const b = xo(() => {
      m.current = 0, f.current && J();
    }), te = Ir(f.current);
    te.addEventListener("resize", b);
    let Z;
    return typeof ResizeObserver < "u" && (Z = new ResizeObserver(b), Z.observe(f.current)), () => {
      b.clear(), te.removeEventListener("resize", b), Z && Z.disconnect();
    };
  }), ko(() => {
    F();
  }), he.useEffect(() => {
    m.current = 0;
  }, [o]);
  const X = (b) => {
    m.current = 0, d || F(), n && n(b);
  };
  return /* @__PURE__ */ B(he.Fragment, {
    children: [/* @__PURE__ */ u("textarea", it({
      value: o,
      onChange: X,
      ref: p,
      rows: s,
      style: it({
        height: A.outerHeightStyle,
        overflow: A.overflow ? "hidden" : null
      }, i)
    }, c)), /* @__PURE__ */ u("textarea", {
      "aria-hidden": !0,
      className: r.className,
      readOnly: !0,
      ref: w,
      tabIndex: -1,
      style: it({}, Ao.shadow, i, {
        padding: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (In.propTypes = {
  className: oe.exports.string,
  maxRows: oe.exports.oneOfType([oe.exports.number, oe.exports.string]),
  minRows: oe.exports.oneOfType([oe.exports.number, oe.exports.string]),
  onChange: oe.exports.func,
  placeholder: oe.exports.string,
  style: oe.exports.object,
  value: oe.exports.oneOfType([oe.exports.arrayOf(oe.exports.string), oe.exports.number, oe.exports.string])
});
const Oo = In;
function Br(e) {
  e = e.trim();
  try {
    if (e = JSON.stringify(JSON.parse(e)), e[0] === "[")
      return be("array", JSON.parse(e));
    if (e[0] === "{")
      return be("object", JSON.parse(e));
    if (e.match(/\-?\d+\.\d+/) && e.match(/\-?\d+\.\d+/)[0] === e)
      return be("float", parseFloat(e));
    if (e.match(/\-?\d+e-\d+/) && e.match(/\-?\d+e-\d+/)[0] === e)
      return be("float", Number(e));
    if (e.match(/\-?\d+/) && e.match(/\-?\d+/)[0] === e)
      return be("integer", parseInt(e));
    if (e.match(/\-?\d+e\+\d+/) && e.match(/\-?\d+e\+\d+/)[0] === e)
      return be("integer", Number(e));
  } catch {
  }
  switch (e = e.toLowerCase(), e) {
    case "undefined":
      return be("undefined", void 0);
    case "nan":
      return be("nan", NaN);
    case "null":
      return be("null", null);
    case "true":
      return be("boolean", !0);
    case "false":
      return be("boolean", !1);
    default:
      if (e = Date.parse(e), e)
        return be("date", new Date(e));
  }
  return be(!1, null);
}
function be(e, r) {
  return {
    type: e,
    value: r
  };
}
const To = (e) => {
  const r = ye(e);
  let t;
  switch (r) {
    case "undefined": {
      t = "undefined";
      break;
    }
    case "nan":
      t = "NaN";
      break;
    case "string":
      t = e;
      break;
    case "date":
      t = e.toString();
      break;
    case "function":
      t = e.toString();
      break;
    case "regexp":
      t = e.toString();
      break;
    default:
      try {
        t = JSON.stringify(e, null, "  ");
      } catch {
        t = "";
      }
  }
  return t;
};
class Ln extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "copiedTimer", null);
    R(this, "handleCopy", () => {
      const t = document.createElement("textarea"), {
        clickCallback: n,
        src: a,
        namespace: s
      } = this.props;
      t.innerHTML = JSON.stringify(this.clipboardValue(a), null, "  "), document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t), this.copiedTimer = setTimeout(() => {
        this.setState({
          copied: !1
        });
      }, 5500), this.setState({
        copied: !0
      }, () => {
        typeof n == "function" && n({
          src: a,
          namespace: s,
          name: s[s.length - 1]
        });
      });
    });
    R(this, "getClippyIcon", () => {
      const {
        theme: t
      } = this.props;
      return this.state.copied ? /* @__PURE__ */ B("span", {
        children: [/* @__PURE__ */ u(Sr, {
          class: "copy-icon",
          ...y(t, "copy-icon")
        }), /* @__PURE__ */ u("span", {
          ...y(t, "copy-icon-copied"),
          children: "\u2714"
        })]
      }) : /* @__PURE__ */ u(Sr, {
        class: "copy-icon",
        ...y(t, "copy-icon")
      });
    });
    R(this, "clipboardValue", (t) => {
      switch (ye(t)) {
        case "function":
        case "regexp":
          return t.toString();
        default:
          return t;
      }
    });
    this.state = {
      copied: !1
    };
  }
  componentWillUnmount() {
    this.copiedTimer && (clearTimeout(this.copiedTimer), this.copiedTimer = null);
  }
  render() {
    const {
      src: t,
      theme: n,
      hidden: a,
      rowHovered: s
    } = this.props, i = y(n, "copy-to-clipboard").style;
    let o = "inline";
    return a && (o = "none"), /* @__PURE__ */ u("span", {
      className: "copy-to-clipboard-container",
      title: "Copy to clipboard",
      style: {
        verticalAlign: "top",
        display: s ? "inline-block" : "none"
      },
      children: /* @__PURE__ */ u("span", {
        style: {
          ...i,
          display: o
        },
        onClick: this.handleCopy,
        children: this.getClippyIcon()
      })
    });
  }
}
class Be extends q.PureComponent {
  render() {
    const {
      rjvId: r,
      type_name: t,
      displayDataTypes: n,
      theme: a
    } = this.props;
    return n ? /* @__PURE__ */ u("span", {
      className: "data-type-label",
      ...y(a, "data-type-label"),
      children: t
    }) : null;
  }
}
class qr extends q.PureComponent {
  render() {
    const r = "bool", {
      props: t
    } = this;
    return /* @__PURE__ */ B("div", {
      ...y(t.theme, "boolean"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: r,
        ...t
      }), t.value ? "true" : "false"]
    });
  }
}
class zr extends q.PureComponent {
  render() {
    const r = "date", {
      props: t
    } = this, n = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    };
    return /* @__PURE__ */ B("div", {
      ...y(t.theme, "date"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: r,
        ...t
      }), /* @__PURE__ */ u("span", {
        className: "date-value",
        ...y(t.theme, "date-value"),
        children: t.value.toLocaleTimeString("en-us", n)
      })]
    });
  }
}
class Vr extends q.PureComponent {
  render() {
    const r = "float", {
      props: t
    } = this;
    return /* @__PURE__ */ B("div", {
      ...y(t.theme, "float"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: r,
        ...t
      }), this.props.value]
    });
  }
}
class Wr extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "toggleCollapsed", () => {
      this.setState({
        collapsed: !this.state.collapsed
      }, () => {
        ue.set(this.props.rjvId, this.props.namespace, "collapsed", this.state.collapsed);
      });
    });
    R(this, "getFunctionDisplay", (t) => {
      const {
        props: n
      } = this;
      return t ? /* @__PURE__ */ B("span", {
        children: [this.props.value.toString().slice(9, -1).replace(/\{[\s\S]+/, ""), /* @__PURE__ */ B("span", {
          className: "function-collapsed",
          style: {
            fontWeight: "bold"
          },
          children: [/* @__PURE__ */ u("span", {
            children: "{"
          }), /* @__PURE__ */ u("span", {
            ...y(n.theme, "ellipsis"),
            children: "..."
          }), /* @__PURE__ */ u("span", {
            children: "}"
          })]
        })]
      }) : this.props.value.toString().slice(9, -1);
    });
    this.state = {
      collapsed: ue.get(t.rjvId, t.namespace, "collapsed", !0)
    };
  }
  render() {
    const t = "function", {
      props: n
    } = this, {
      collapsed: a
    } = this.state;
    return /* @__PURE__ */ B("div", {
      ...y(n.theme, "function"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: t,
        ...n
      }), /* @__PURE__ */ u("span", {
        ...y(n.theme, "function-value"),
        className: "rjv-function-container",
        onClick: this.toggleCollapsed,
        children: this.getFunctionDisplay(a)
      })]
    });
  }
}
class $r extends q.PureComponent {
  render() {
    const r = "int", {
      props: t
    } = this;
    return /* @__PURE__ */ B("div", {
      ...y(t.theme, "integer"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: r,
        ...t
      }), this.props.value]
    });
  }
}
class Kr extends q.PureComponent {
  render() {
    return /* @__PURE__ */ u("div", {
      ...y(this.props.theme, "nan"),
      children: "NaN"
    });
  }
}
class Ur extends q.PureComponent {
  render() {
    return /* @__PURE__ */ u("div", {
      ...y(this.props.theme, "null"),
      children: "NULL"
    });
  }
}
class Po extends q.PureComponent {
  render() {
    const r = "regexp", {
      props: t
    } = this;
    return /* @__PURE__ */ B("div", {
      ...y(t.theme, "regexp"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: r,
        ...t
      }), this.props.value.toString()]
    });
  }
}
class Yr extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "toggleCollapsed", () => {
      this.setState({
        collapsed: !this.state.collapsed
      }, () => {
        ue.set(this.props.rjvId, this.props.namespace, "collapsed", this.state.collapsed);
      });
    });
    this.state = {
      collapsed: ue.get(t.rjvId, t.namespace, "collapsed", !0)
    };
  }
  render() {
    const t = "string";
    this.state;
    const {
      props: n
    } = this, {
      collapseStringsAfterLength: a,
      theme: s
    } = n;
    let {
      value: i
    } = n;
    const o = ye(a) === "integer", c = {
      style: {
        cursor: "default"
      }
    };
    return o && i.length > a && (c.style.cursor = "pointer", this.state.collapsed && (i = /* @__PURE__ */ B("span", {
      children: [i.substring(0, a), /* @__PURE__ */ u("span", {
        ...y(s, "ellipsis"),
        children: " ..."
      })]
    }))), /* @__PURE__ */ B("div", {
      ...y(s, "string"),
      children: [/* @__PURE__ */ u(Be, {
        type_name: t,
        ...n
      }), /* @__PURE__ */ B("span", {
        className: "string-value",
        ...c,
        onClick: this.toggleCollapsed,
        children: ['"', i, '"']
      })]
    });
  }
}
class Hr extends q.PureComponent {
  render() {
    return /* @__PURE__ */ u("div", {
      ...y(this.props.theme, "undefined"),
      children: "undefined"
    });
  }
}
class jo extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "getEditIcon", () => {
      const {
        variable: t,
        theme: n
      } = this.props;
      return /* @__PURE__ */ u("div", {
        className: "click-to-edit",
        style: {
          verticalAlign: "top",
          display: this.state.hovered ? "inline-block" : "none"
        },
        children: /* @__PURE__ */ u(fo, {
          class: "click-to-edit-icon",
          ...y(n, "editVarIcon"),
          onClick: () => {
            this.prepopInput(t);
          }
        })
      });
    });
    R(this, "prepopInput", (t) => {
      if (this.props.onEdit !== !1) {
        const n = To(t.value), a = Br(n);
        this.setState({
          editMode: !0,
          editValue: n,
          parsedInput: {
            type: a.type,
            value: a.value
          }
        });
      }
    });
    R(this, "getRemoveIcon", () => {
      const {
        variable: t,
        namespace: n,
        theme: a,
        rjvId: s
      } = this.props;
      return /* @__PURE__ */ u("div", {
        className: "click-to-remove",
        style: {
          verticalAlign: "top",
          display: this.state.hovered ? "inline-block" : "none"
        },
        children: /* @__PURE__ */ u(zt, {
          class: "click-to-remove-icon",
          ...y(a, "removeVarIcon"),
          onClick: () => {
            Re.dispatch({
              name: "VARIABLE_REMOVED",
              rjvId: s,
              data: {
                name: t.name,
                namespace: n,
                existing_value: t.value,
                variable_removed: !0
              }
            });
          }
        })
      });
    });
    R(this, "getValue", (t, n) => {
      const a = n ? !1 : t.type, {
        props: s
      } = this;
      switch (a) {
        case !1:
          return this.getEditInput();
        case "string":
          return /* @__PURE__ */ u(Yr, {
            value: t.value,
            ...s
          });
        case "integer":
          return /* @__PURE__ */ u($r, {
            value: t.value,
            ...s
          });
        case "float":
          return /* @__PURE__ */ u(Vr, {
            value: t.value,
            ...s
          });
        case "boolean":
          return /* @__PURE__ */ u(qr, {
            value: t.value,
            ...s
          });
        case "function":
          return /* @__PURE__ */ u(Wr, {
            value: t.value,
            ...s
          });
        case "null":
          return /* @__PURE__ */ u(Ur, {
            ...s
          });
        case "nan":
          return /* @__PURE__ */ u(Kr, {
            ...s
          });
        case "undefined":
          return /* @__PURE__ */ u(Hr, {
            ...s
          });
        case "date":
          return /* @__PURE__ */ u(zr, {
            value: t.value,
            ...s
          });
        case "regexp":
          return /* @__PURE__ */ u(Po, {
            value: t.value,
            ...s
          });
        default:
          return /* @__PURE__ */ u("div", {
            className: "object-value",
            children: JSON.stringify(t.value)
          });
      }
    });
    R(this, "getEditInput", () => {
      const {
        theme: t
      } = this.props, {
        editValue: n
      } = this.state;
      return /* @__PURE__ */ B("div", {
        children: [/* @__PURE__ */ u(Oo, {
          type: "text",
          inputRef: (a) => a && a.focus(),
          value: n,
          class: "variable-editor",
          onChange: (a) => {
            const s = a.target.value, i = Br(s);
            this.setState({
              editValue: s,
              parsedInput: {
                type: i.type,
                value: i.value
              }
            });
          },
          onKeyDown: (a) => {
            switch (a.key) {
              case "Escape": {
                this.setState({
                  editMode: !1,
                  editValue: ""
                });
                break;
              }
              case "Enter": {
                (a.ctrlKey || a.metaKey) && this.submitEdit(!0);
                break;
              }
            }
            a.stopPropagation();
          },
          placeholder: "update this value",
          minRows: 2,
          ...y(t, "edit-input")
        }), /* @__PURE__ */ B("div", {
          ...y(t, "edit-icon-container"),
          children: [/* @__PURE__ */ u(zt, {
            class: "edit-cancel",
            ...y(t, "cancel-icon"),
            onClick: () => {
              this.setState({
                editMode: !1,
                editValue: ""
              });
            }
          }), /* @__PURE__ */ u(Vt, {
            class: "edit-check string-value",
            ...y(t, "check-icon"),
            onClick: () => {
              this.submitEdit();
            }
          }), /* @__PURE__ */ u("div", {
            children: this.showDetected()
          })]
        })]
      });
    });
    R(this, "submitEdit", (t) => {
      const {
        variable: n,
        namespace: a,
        rjvId: s
      } = this.props, {
        editValue: i,
        parsedInput: o
      } = this.state;
      let c = i;
      t && o.type && (c = o.value), this.setState({
        editMode: !1
      }), Re.dispatch({
        name: "VARIABLE_UPDATED",
        rjvId: s,
        data: {
          name: n.name,
          namespace: a,
          existing_value: n.value,
          new_value: c,
          variable_removed: !1
        }
      });
    });
    R(this, "showDetected", () => {
      const {
        theme: t,
        variable: n,
        namespace: a,
        rjvId: s
      } = this.props;
      this.state.parsedInput;
      const i = this.getDetectedInput();
      if (i)
        return /* @__PURE__ */ u("div", {
          children: /* @__PURE__ */ B("div", {
            ...y(t, "detected-row"),
            children: [i, /* @__PURE__ */ u(Vt, {
              class: "edit-check detected",
              style: {
                verticalAlign: "top",
                paddingLeft: "3px",
                ...y(t, "check-icon").style
              },
              onClick: () => {
                this.submitEdit(!0);
              }
            })]
          })
        });
    });
    R(this, "getDetectedInput", () => {
      const {
        parsedInput: t
      } = this.state, {
        type: n,
        value: a
      } = t, {
        props: s
      } = this, {
        theme: i
      } = s;
      if (n !== !1)
        switch (n.toLowerCase()) {
          case "object":
            return /* @__PURE__ */ B("span", {
              children: [/* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "brace").style,
                  cursor: "default"
                },
                children: "{"
              }), /* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "ellipsis").style,
                  cursor: "default"
                },
                children: "..."
              }), /* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "brace").style,
                  cursor: "default"
                },
                children: "}"
              })]
            });
          case "array":
            return /* @__PURE__ */ B("span", {
              children: [/* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "brace").style,
                  cursor: "default"
                },
                children: "["
              }), /* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "ellipsis").style,
                  cursor: "default"
                },
                children: "..."
              }), /* @__PURE__ */ u("span", {
                style: {
                  ...y(i, "brace").style,
                  cursor: "default"
                },
                children: "]"
              })]
            });
          case "string":
            return /* @__PURE__ */ u(Yr, {
              value: a,
              ...s
            });
          case "integer":
            return /* @__PURE__ */ u($r, {
              value: a,
              ...s
            });
          case "float":
            return /* @__PURE__ */ u(Vr, {
              value: a,
              ...s
            });
          case "boolean":
            return /* @__PURE__ */ u(qr, {
              value: a,
              ...s
            });
          case "function":
            return /* @__PURE__ */ u(Wr, {
              value: a,
              ...s
            });
          case "null":
            return /* @__PURE__ */ u(Ur, {
              ...s
            });
          case "nan":
            return /* @__PURE__ */ u(Kr, {
              ...s
            });
          case "undefined":
            return /* @__PURE__ */ u(Hr, {
              ...s
            });
          case "date":
            return /* @__PURE__ */ u(zr, {
              value: new Date(a),
              ...s
            });
        }
    });
    this.state = {
      editMode: !1,
      editValue: "",
      hovered: !1,
      renameKey: !1,
      parsedInput: {
        type: !1,
        value: null
      }
    };
  }
  render() {
    const {
      variable: t,
      singleIndent: n,
      type: a,
      theme: s,
      namespace: i,
      indentWidth: o,
      enableClipboard: c,
      onEdit: d,
      onDelete: f,
      onSelect: p,
      displayArrayKey: w,
      quotesOnKeys: m
    } = this.props, {
      editMode: A
    } = this.state;
    return /* @__PURE__ */ nt("div", {
      ...y(s, "objectKeyVal", {
        paddingLeft: o * n
      }),
      onMouseEnter: () => this.setState({
        ...this.state,
        hovered: !0
      }),
      onMouseLeave: () => this.setState({
        ...this.state,
        hovered: !1
      }),
      className: "variable-row",
      key: t.name
    }, a == "array" ? w ? /* @__PURE__ */ nt("span", {
      ...y(s, "array-key"),
      key: t.name + "_" + i
    }, t.name, /* @__PURE__ */ u("div", {
      ...y(s, "colon"),
      children: ":"
    })) : null : /* @__PURE__ */ B("span", {
      children: [/* @__PURE__ */ nt("span", {
        ...y(s, "object-name"),
        className: "object-key",
        key: t.name + "_" + i
      }, !!m && /* @__PURE__ */ u("span", {
        style: {
          verticalAlign: "top"
        },
        children: '"'
      }), /* @__PURE__ */ u("span", {
        style: {
          display: "inline-block"
        },
        children: t.name
      }), !!m && /* @__PURE__ */ u("span", {
        style: {
          verticalAlign: "top"
        },
        children: '"'
      })), /* @__PURE__ */ u("span", {
        ...y(s, "colon"),
        children: ":"
      })]
    }), /* @__PURE__ */ u("div", {
      className: "variable-value",
      onClick: p === !1 && d === !1 ? null : (O) => {
        const k = [...i];
        (O.ctrlKey || O.metaKey) && d !== !1 ? this.prepopInput(t) : p !== !1 && (k.shift(), p({
          ...t,
          namespace: k
        }));
      },
      ...y(s, "variableValue", {
        cursor: p === !1 ? "default" : "pointer"
      }),
      children: this.getValue(t, A)
    }), c ? /* @__PURE__ */ u(Ln, {
      rowHovered: this.state.hovered,
      hidden: A,
      src: t.value,
      clickCallback: c,
      theme: s,
      namespace: [...i, t.name]
    }) : null, d !== !1 && A == !1 ? this.getEditIcon() : null, f !== !1 && A == !1 ? this.getRemoveIcon() : null);
  }
}
class Nn extends q.PureComponent {
  constructor() {
    super(...arguments);
    R(this, "getObjectSize", () => {
      const {
        size: t,
        theme: n,
        displayObjectSize: a
      } = this.props;
      if (a)
        return /* @__PURE__ */ B("span", {
          className: "object-size",
          ...y(n, "object-size"),
          children: [t, " item", t === 1 ? "" : "s"]
        });
    });
    R(this, "getAddAttribute", (t) => {
      const {
        theme: n,
        namespace: a,
        name: s,
        src: i,
        rjvId: o,
        depth: c
      } = this.props;
      return /* @__PURE__ */ u("span", {
        className: "click-to-add",
        style: {
          verticalAlign: "top",
          display: t ? "inline-block" : "none"
        },
        children: /* @__PURE__ */ u(uo, {
          class: "click-to-add-icon",
          ...y(n, "addVarIcon"),
          onClick: () => {
            const d = {
              name: c > 0 ? s : null,
              namespace: a.splice(0, a.length - 1),
              existing_value: i,
              variable_removed: !1,
              key_name: null
            };
            ye(i) === "object" ? Re.dispatch({
              name: "ADD_VARIABLE_KEY_REQUEST",
              rjvId: o,
              data: d
            }) : Re.dispatch({
              name: "VARIABLE_ADDED",
              rjvId: o,
              data: {
                ...d,
                new_value: [...i, null]
              }
            });
          }
        })
      });
    });
    R(this, "getRemoveObject", (t) => {
      const {
        theme: n,
        hover: a,
        namespace: s,
        name: i,
        src: o,
        rjvId: c
      } = this.props;
      if (s.length !== 1)
        return /* @__PURE__ */ u("span", {
          className: "click-to-remove",
          style: {
            display: t ? "inline-block" : "none"
          },
          children: /* @__PURE__ */ u(zt, {
            class: "click-to-remove-icon",
            ...y(n, "removeVarIcon"),
            onClick: () => {
              Re.dispatch({
                name: "VARIABLE_REMOVED",
                rjvId: c,
                data: {
                  name: i,
                  namespace: s.splice(0, s.length - 1),
                  existing_value: o,
                  variable_removed: !0
                }
              });
            }
          })
        });
    });
    R(this, "render", () => {
      const {
        theme: t,
        onDelete: n,
        onAdd: a,
        enableClipboard: s,
        src: i,
        namespace: o,
        rowHovered: c
      } = this.props;
      return /* @__PURE__ */ B("div", {
        ...y(t, "object-meta-data"),
        className: "object-meta-data",
        onClick: (d) => {
          d.stopPropagation();
        },
        children: [this.getObjectSize(), s ? /* @__PURE__ */ u(Ln, {
          rowHovered: c,
          clickCallback: s,
          src: i,
          theme: t,
          namespace: o
        }) : null, a !== !1 ? this.getAddAttribute(c) : null, n !== !1 ? this.getRemoveObject(c) : null]
      });
    });
  }
}
const Gr = 1, Jr = 5, Ye = class extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "toggleCollapsed", () => {
      this.setState({
        expanded: !this.state.expanded
      }, () => {
        ue.set(this.props.rjvId, this.props.namespace, "expanded", this.state.expanded);
      });
    });
    R(this, "getObjectContent", (t, n, a) => /* @__PURE__ */ u("div", {
      className: "pushed-content object-container",
      children: /* @__PURE__ */ u("div", {
        className: "object-content",
        ...y(this.props.theme, "pushed-content"),
        children: this.renderObjectContents(n, a)
      })
    }));
    R(this, "getEllipsis", () => {
      const {
        size: t
      } = this.state;
      return t === 0 ? null : /* @__PURE__ */ u("div", {
        ...y(this.props.theme, "ellipsis"),
        className: "node-ellipsis",
        onClick: this.toggleCollapsed,
        children: "..."
      });
    });
    R(this, "getObjectMetaData", (t) => {
      this.props;
      const {
        size: n,
        hovered: a
      } = this.state;
      return /* @__PURE__ */ u(Nn, {
        rowHovered: a,
        size: n,
        ...this.props
      });
    });
    R(this, "renderObjectContents", (t, n) => {
      const {
        depth: a,
        parent_type: s,
        index_offset: i,
        groupArraysAfterLength: o,
        namespace: c
      } = this.props, {
        object_type: d
      } = this.state, f = [];
      let p, w = Object.keys(t || {});
      return this.props.sortKeys && d !== "array" && (w = w.sort()), w.forEach((m) => {
        if (p = new Fo(m, t[m]), s === "array_group" && i && (p.name = parseInt(p.name) + i), t.hasOwnProperty(m))
          if (p.type === "object")
            f.push(/* @__PURE__ */ u(Ye, {
              depth: a + Gr,
              name: p.name,
              src: p.value,
              namespace: c.concat(p.name),
              parent_type: d,
              ...n
            }, p.name));
          else if (p.type === "array") {
            let A = Ye;
            o && p.value.length > o && (A = Bn), f.push(/* @__PURE__ */ u(A, {
              depth: a + Gr,
              name: p.name,
              src: p.value,
              namespace: c.concat(p.name),
              type: "array",
              parent_type: d,
              ...n
            }, p.name));
          } else
            f.push(/* @__PURE__ */ u(jo, {
              variable: p,
              singleIndent: Jr,
              namespace: c,
              type: this.props.type,
              ...n
            }, p.name + "_" + c));
      }), f;
    });
    const n = Ye.getState(t);
    this.state = {
      ...n,
      prevProps: {}
    };
  }
  static getDerivedStateFromProps(t, n) {
    const {
      prevProps: a
    } = n;
    return t.src !== a.src || t.collapsed !== a.collapsed || t.name !== a.name || t.namespace !== a.namespace || t.rjvId !== a.rjvId ? {
      ...Ye.getState(t),
      prevProps: t
    } : null;
  }
  getBraceStart(t, n) {
    const {
      src: a,
      theme: s,
      iconStyle: i,
      parent_type: o
    } = this.props;
    if (o === "array_group")
      return /* @__PURE__ */ B("span", {
        children: [/* @__PURE__ */ u("span", {
          ...y(s, "brace"),
          children: t === "array" ? "[" : "{"
        }), n ? this.getObjectMetaData(a) : null]
      });
    const c = n ? jn : Fn;
    return /* @__PURE__ */ B("span", {
      children: [/* @__PURE__ */ B("span", {
        onClick: (d) => {
          this.toggleCollapsed();
        },
        ...y(s, "brace-row"),
        children: [/* @__PURE__ */ u("div", {
          className: "icon-container",
          ...y(s, "icon-container"),
          children: /* @__PURE__ */ u(c, {
            theme: s,
            iconStyle: i
          })
        }), /* @__PURE__ */ u(Tn, {
          ...this.props
        }), /* @__PURE__ */ u("span", {
          ...y(s, "brace"),
          children: t === "array" ? "[" : "{"
        })]
      }), n ? this.getObjectMetaData(a) : null]
    });
  }
  render() {
    const {
      depth: t,
      src: n,
      namespace: a,
      name: s,
      type: i,
      parent_type: o,
      theme: c,
      jsvRoot: d,
      iconStyle: f,
      ...p
    } = this.props, {
      object_type: w,
      expanded: m
    } = this.state, A = {};
    return !d && o !== "array_group" ? A.paddingLeft = this.props.indentWidth * Jr : o === "array_group" && (A.borderLeft = 0, A.display = "inline"), /* @__PURE__ */ B("div", {
      className: "object-key-val",
      onMouseEnter: () => this.setState({
        ...this.state,
        hovered: !0
      }),
      onMouseLeave: () => this.setState({
        ...this.state,
        hovered: !1
      }),
      ...y(c, d ? "jsv-root" : "objectKeyVal", A),
      children: [this.getBraceStart(w, m), m ? this.getObjectContent(t, n, {
        theme: c,
        iconStyle: f,
        ...p
      }) : this.getEllipsis(), /* @__PURE__ */ B("span", {
        className: "brace-row",
        children: [/* @__PURE__ */ u("span", {
          style: {
            ...y(c, "brace").style,
            paddingLeft: m ? "3px" : "0px"
          },
          children: w === "array" ? "]" : "}"
        }), m ? null : this.getObjectMetaData(n)]
      })]
    });
  }
};
let Je = Ye;
R(Je, "getState", (t) => {
  const n = Object.keys(t.src).length, a = (t.collapsed === !1 || t.collapsed !== !0 && t.collapsed > t.depth) && (!t.shouldCollapse || t.shouldCollapse({
    name: t.name,
    src: t.src,
    type: ye(t.src),
    namespace: t.namespace
  }) === !1) && n !== 0;
  return {
    expanded: ue.get(t.rjvId, t.namespace, "expanded", a),
    object_type: t.type === "array" ? "array" : "object",
    parent_type: t.type === "array" ? "array" : "object",
    size: n,
    hovered: !1
  };
});
class Fo {
  constructor(r, t) {
    this.name = r, this.value = t, this.type = ye(t);
  }
}
tn(Je);
const Xr = 5;
class Bn extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "toggleCollapsed", (t) => {
      const n = [];
      for (const a in this.state.expanded)
        n.push(this.state.expanded[a]);
      n[t] = !n[t], this.setState({
        expanded: n
      });
    });
    this.state = {
      expanded: []
    };
  }
  getExpandedIcon(t) {
    const {
      theme: n,
      iconStyle: a
    } = this.props;
    return this.state.expanded[t] ? /* @__PURE__ */ u(jn, {
      theme: n,
      iconStyle: a
    }) : /* @__PURE__ */ u(Fn, {
      theme: n,
      iconStyle: a
    });
  }
  render() {
    const {
      src: t,
      groupArraysAfterLength: n,
      depth: a,
      name: s,
      theme: i,
      jsvRoot: o,
      namespace: c,
      parent_type: d,
      ...f
    } = this.props;
    let p = 0;
    const w = this.props.indentWidth * Xr;
    o || (p = this.props.indentWidth * Xr);
    const m = n, A = Math.ceil(t.length / m);
    return /* @__PURE__ */ B("div", {
      className: "object-key-val",
      ...y(i, o ? "jsv-root" : "objectKeyVal", {
        paddingLeft: p
      }),
      children: [/* @__PURE__ */ u(Tn, {
        ...this.props
      }), /* @__PURE__ */ u("span", {
        children: /* @__PURE__ */ u(Nn, {
          size: t.length,
          ...this.props
        })
      }), [...Array(A)].map((O, k) => /* @__PURE__ */ u("div", {
        className: "object-key-val array-group",
        ...y(i, "objectKeyVal", {
          marginLeft: 6,
          paddingLeft: w
        }),
        children: /* @__PURE__ */ B("span", {
          ...y(i, "brace-row"),
          children: [/* @__PURE__ */ u("div", {
            className: "icon-container",
            ...y(i, "icon-container"),
            onClick: (W) => {
              this.toggleCollapsed(k);
            },
            children: this.getExpandedIcon(k)
          }), this.state.expanded[k] ? /* @__PURE__ */ u(Je, {
            depth: 0,
            name: !1,
            collapsed: !1,
            groupArraysAfterLength: m,
            index_offset: k * m,
            src: t.slice(k * m, k * m + m),
            namespace: c,
            type: "array",
            parent_type: "array_group",
            theme: i,
            ...f
          }, s + k) : /* @__PURE__ */ B("span", {
            ...y(i, "brace"),
            onClick: (W) => {
              this.toggleCollapsed(k);
            },
            className: "array-group-brace",
            children: ["[", /* @__PURE__ */ u("div", {
              ...y(i, "array-group-meta-data"),
              className: "array-group-meta-data",
              children: /* @__PURE__ */ B("span", {
                className: "object-size",
                ...y(i, "object-size"),
                children: [k * m, " - ", k * m + m > t.length ? t.length : k * m + m]
              })
            }), "]"]
          })]
        })
      }, k))]
    });
  }
}
class Mo extends q.PureComponent {
  constructor() {
    super(...arguments);
    R(this, "render", () => {
      const {
        props: t
      } = this, n = [t.name];
      let a = Je;
      return Array.isArray(t.src) && t.groupArraysAfterLength && t.src.length > t.groupArraysAfterLength && (a = Bn), /* @__PURE__ */ u("div", {
        className: "pretty-json-container object-container",
        children: /* @__PURE__ */ u("div", {
          className: "object-content",
          children: /* @__PURE__ */ u(a, {
            namespace: n,
            depth: 0,
            jsvRoot: !0,
            ...t
          })
        })
      });
    });
  }
}
class Do extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "closeModal", () => {
      Re.dispatch({
        rjvId: this.props.rjvId,
        name: "RESET"
      });
    });
    R(this, "submit", () => {
      this.props.submit(this.state.input);
    });
    this.state = {
      input: t.input ? t.input : ""
    };
  }
  render() {
    const {
      theme: t,
      rjvId: n,
      isValid: a
    } = this.props, {
      input: s
    } = this.state, i = a(s);
    return /* @__PURE__ */ u("div", {
      className: "key-modal-request",
      ...y(t, "key-modal-request"),
      onClick: this.closeModal,
      children: /* @__PURE__ */ B("div", {
        ...y(t, "key-modal"),
        onClick: (o) => {
          o.stopPropagation();
        },
        children: [/* @__PURE__ */ u("div", {
          ...y(t, "key-modal-label"),
          children: "Key Name:"
        }), /* @__PURE__ */ B("div", {
          style: {
            position: "relative"
          },
          children: [/* @__PURE__ */ u("input", {
            ...y(t, "key-modal-input"),
            className: "key-modal-input",
            ref: (o) => o && o.focus(),
            spellCheck: !1,
            value: s,
            placeholder: "...",
            onChange: (o) => {
              this.setState({
                input: o.target.value
              });
            },
            onKeyPress: (o) => {
              i && o.key === "Enter" ? this.submit() : o.key === "Escape" && this.closeModal();
            }
          }), i ? /* @__PURE__ */ u(Vt, {
            ...y(t, "key-modal-submit"),
            class: "key-modal-submit",
            onClick: (o) => this.submit()
          }) : null]
        }), /* @__PURE__ */ u("span", {
          ...y(t, "key-modal-cancel"),
          children: /* @__PURE__ */ u(Pn, {
            ...y(t, "key-modal-cancel-icon"),
            class: "key-modal-cancel",
            onClick: () => {
              Re.dispatch({
                rjvId: n,
                name: "RESET"
              });
            }
          })
        })]
      })
    });
  }
}
class Io extends q.PureComponent {
  constructor() {
    super(...arguments);
    R(this, "isValid", (t) => {
      const {
        rjvId: n
      } = this.props, a = ue.get(n, "action", "new-key-request");
      return t != "" && Object.keys(a.existing_value).indexOf(t) === -1;
    });
    R(this, "submit", (t) => {
      const {
        rjvId: n
      } = this.props, a = ue.get(n, "action", "new-key-request");
      a.new_value = {
        ...a.existing_value
      }, a.new_value[t] = this.props.defaultValue, Re.dispatch({
        name: "VARIABLE_ADDED",
        rjvId: n,
        data: a
      });
    });
  }
  render() {
    const {
      active: t,
      theme: n,
      rjvId: a
    } = this.props;
    return t ? /* @__PURE__ */ u(Do, {
      rjvId: a,
      theme: n,
      isValid: this.isValid,
      submit: this.submit
    }) : null;
  }
}
class Lo extends q.PureComponent {
  render() {
    const {
      message: r,
      active: t,
      theme: n,
      rjvId: a
    } = this.props;
    return t ? /* @__PURE__ */ B("div", {
      className: "validation-failure",
      ...y(n, "validation-failure"),
      onClick: () => {
        Re.dispatch({
          rjvId: a,
          name: "RESET"
        });
      },
      children: [/* @__PURE__ */ u("span", {
        ...y(n, "validation-failure-label"),
        children: r
      }), /* @__PURE__ */ u(Pn, {
        ...y(n, "validation-failure-clear")
      })]
    }) : null;
  }
}
const ke = class extends q.PureComponent {
  constructor(t) {
    super(t);
    R(this, "rjvId", Date.now().toString());
    R(this, "getListeners", () => ({
      reset: this.resetState,
      "variable-update": this.updateSrc,
      "add-key-request": this.addKeyRequest
    }));
    R(this, "updateSrc", () => {
      const {
        name: t,
        namespace: n,
        new_value: a,
        existing_value: s,
        updated_src: i,
        type: o
      } = ue.get(this.rjvId, "action", "variable-update"), {
        onEdit: c,
        onDelete: d,
        onAdd: f
      } = this.props, {
        src: p
      } = this.state;
      let w;
      const m = {
        existing_src: p,
        new_value: a,
        updated_src: i,
        name: t,
        namespace: n,
        existing_value: s
      };
      switch (o) {
        case "variable-added":
          w = f(m);
          break;
        case "variable-edited":
          w = c(m);
          break;
        case "variable-removed":
          w = d(m);
          break;
      }
      w !== !1 ? (ue.set(this.rjvId, "global", "src", i), this.setState({
        src: i
      })) : this.setState({
        validationFailure: !0
      });
    });
    R(this, "addKeyRequest", () => {
      this.setState({
        addKeyRequest: !0
      });
    });
    R(this, "resetState", () => {
      this.setState({
        validationFailure: !1,
        addKeyRequest: !1
      });
    });
    this.state = {
      addKeyRequest: !1,
      editKeyRequest: !1,
      validationFailure: !1,
      src: ke.defaultProps.src,
      name: ke.defaultProps.name,
      theme: ke.defaultProps.theme,
      validationMessage: ke.defaultProps.validationMessage,
      prevSrc: ke.defaultProps.src,
      prevName: ke.defaultProps.name,
      prevTheme: ke.defaultProps.theme
    };
  }
  static getDerivedStateFromProps(t, n) {
    if (t.src !== n.prevSrc || t.name !== n.prevName || t.theme !== n.prevTheme) {
      const a = {
        src: t.src,
        name: t.name,
        theme: t.theme,
        validationMessage: t.validationMessage,
        prevSrc: t.src,
        prevName: t.name,
        prevTheme: t.theme
      };
      return ke.validateState(a);
    }
    return null;
  }
  componentDidMount() {
    ue.set(this.rjvId, "global", "src", this.state.src);
    const t = this.getListeners();
    for (const n in t)
      ue.on(n + "-" + this.rjvId, t[n]);
    this.setState({
      addKeyRequest: !1,
      editKeyRequest: !1
    });
  }
  componentDidUpdate(t, n) {
    n.addKeyRequest !== !1 && this.setState({
      addKeyRequest: !1
    }), n.editKeyRequest !== !1 && this.setState({
      editKeyRequest: !1
    }), t.src !== this.state.src && ue.set(this.rjvId, "global", "src", this.state.src);
  }
  componentWillUnmount() {
    const t = this.getListeners();
    for (const n in t)
      ue.removeListener(n + "-" + this.rjvId, t[n]);
  }
  render() {
    const {
      validationFailure: t,
      validationMessage: n,
      addKeyRequest: a,
      theme: s,
      src: i,
      name: o
    } = this.state, {
      className: c,
      style: d,
      defaultValue: f
    } = this.props;
    return /* @__PURE__ */ B("div", {
      className: `react-json-view${c ? " " : ""}${c != null ? c : ""}`,
      style: {
        ...y(s, "app-container").style,
        ...d
      },
      children: [/* @__PURE__ */ u(Lo, {
        message: n,
        active: t,
        theme: s,
        rjvId: this.rjvId
      }), /* @__PURE__ */ u(Mo, {
        ...this.props,
        src: i,
        name: o,
        theme: s,
        type: ye(i),
        rjvId: this.rjvId
      }), /* @__PURE__ */ u(Io, {
        active: a,
        theme: s,
        rjvId: this.rjvId,
        defaultValue: f
      })]
    });
  }
};
let rt = ke;
R(rt, "defaultProps", {
  src: {},
  name: "root",
  theme: "rjv-default",
  collapsed: !1,
  collapseStringsAfterLength: !1,
  shouldCollapse: !1,
  sortKeys: !1,
  quotesOnKeys: !0,
  groupArraysAfterLength: 100,
  indentWidth: 4,
  enableClipboard: !0,
  displayObjectSize: !0,
  displayDataTypes: !0,
  onEdit: !1,
  onDelete: !1,
  onAdd: !1,
  onSelect: !1,
  iconStyle: "triangle",
  style: {},
  validationMessage: "Validation Error",
  defaultValue: null,
  displayArrayKey: !0
}), R(rt, "validateState", (t) => {
  const n = {};
  return ye(t.theme) === "object" && !qi(t.theme) && (console.error("react-json-view error:", "theme prop must be a theme name or valid base-16 theme object.", 'defaulting to "rjv-default" theme'), n.theme = "rjv-default"), ye(t.src) !== "object" && ye(t.src) !== "array" && (console.error("react-json-view error:", "src property must be a valid json object"), n.name = "ERROR", n.src = {
    message: "src property must be a valid json object"
  }), {
    ...t,
    ...n
  };
});
tn(rt);
export {
  rt as default
};
